import type { Dict } from "./en";

const it: Dict = {
  grid: {
    controls: { group: "Controlli zoom griglia", zoomIn: "Ingrandisci", zoomOut: "Riduci", fit: "Adatta la griglia alla vista" },
    hud: { aria: "HUD coordinate griglia", instrument: "Strumento", xy: "X · Y", zoom: "Zoom", grid: "Griglia", chain: "Rete" },
    legend: {
      gridZero: { label: "Grid Zero", desc: "Nucleo centrale bloccato" },
      vipCore: { label: "VIP Core", desc: "Anello centrale di pregio · vendibile" },
      premium: { label: "Premium", desc: "Viali e anello interno" },
      reserve: { label: "Riserva", desc: "4 zone riservate bloccate" },
      standard: { label: "Standard", desc: "Territorio generale" },
    },
    loading: { initializing: "Inizializzazione territorio" },
    mode: { aria: "Modalità di interazione griglia", select: "Seleziona", selectHint: "Disegna rettangolo", inspect: "Ispeziona", inspectHint: "Clicca i parcel", itemAria: "Modalità {label} — {hint}" },
    enter3d: { title: "Entra in 3D", fallbackName: "territorio" },
    panel: {
      parcelProfileAria: "Profilo parcel", parcelProfileTitle: "Profilo parcel", parcel: "Parcel",
      territoryName: "Nome territorio", owner: "Proprietario", position: "Posizione", size: "Dimensione", slots: "Slot", zone: "Zona",
      claimBlock: "Blocco di claim", claimTx: "Tx di claim", selectTerritory: "Seleziona territorio",
      emptySelection: "La cella non ha parcel. Clicca un territorio di proprietà per vederne il dossier.",
      emptyDefault: "Clicca un parcel sulla griglia per vedere proprietà, coordinate e identità on-chain.",
      contextAria: "Pannello contesto", panelAria: "Pannello", closePanel: "Chiudi pannello", snapshot: "Snapshot",
      titleArtwork: "Opera", titleSelection: "Selezione", titleContext: "Contesto",
      parcelNum: "Parcel #{id}", selectionSize: "{w} × {h} · {slots} slot", drawRectHint: "Disegna un rettangolo sulla griglia",
    },
    context: {
      emptyTitle: "Nessun territorio selezionato",
      emptyDesc: "Disegna un rettangolo sulla griglia per vedere slot, zona, livello di scarsità e prezzo.",
    },
    detail: {
      fetchFailed: "Recupero dettagli non riuscito: {error}",
      conflict: "Conflitto di invariante dati in questa cella: {count} parcel si sovrappongono. Selezione soppressa.",
      cellOutside: "Fuori dalla griglia ({x}, {y})",
      cellLoadingMap: "Caricamento dati mappa…",
      cellConfirming: "Conferma della cella ({x}, {y})…",
      cellEmpty: "Cella ({x}, {y}): nessun parcel indicizzato in questa cella (al blocco {block})",
      cellConfirmError: "Impossibile confermare lo stato attuale della cella.",
      chainMismatch: "Viewer non disponibile per discordanza di rete.",
      indexerNotReady: "Indexer non pronto — ancora nessuno snapshot.",
      clickHint: "Clicca un parcel per vedere i dettagli.",
      zoneClassifying: "Classificazione…",
      zoneUnavailable: "Non disponibile",
      zoneSaleLocked: "· vendita bloccata",
      zoneMixed: "· zona mista",
    },
    toolbar: {
      territory: "Territorio",
      scrollToZoom: "scorri per lo zoom",
      menu: "Menu",
      openNav: "Apri navigazione",
      hideNav: "Nascondi navigazione",
      revealAreas: "Mostra aree",
      revealAreasAria: "Mostra le zone del territorio",
      zonesUnavailable: "Mappa delle zone non disponibile — nuovo tentativo automatico",
      zonesRetry: "Riprova",
      showDragArtwork: "Mostra e trascina opera",
      showDragArtworkAria: "Mostra e trascina opera",
      showDragArtworkTitle: "Mostra la mia opera sulla griglia e trascinala su un altro parcel",
      loading: "Caricamento…",
      myTerritories: "I miei territori",
    },
    status: {
      live: "ATTIVO", cached: "CACHE", chain: "RETE",
      liveTitle: "Attivo · sincronizzato",
      cachedTitle: "Mostra l'ultimo snapshot noto",
      chainTitle: "Discordanza di rete — dati del viewer soppressi",
    },
    artworkMsg: {
      none: "Non hai ancora Frozen Artwork.",
      noPlaced: "Nessuna opera posizionata da spostare.",
      connectWallet: "Collega il wallet per spostare le tue opere.",
    },
    slotCount: {
      slots: "slot",
      selectedTitle: "{slots} slot selezionati ({w} × {h})",
    },
    bottomSheet: { aria: "Pannello inferiore", dragOpen: "Trascina per ridimensionare o chiudere il pannello", handle: "Maniglia pannello" },
    stats: {
      networkStatus: "Stato rete", live: "Attivo", offline: "Offline", syncing: "Sincronizzazione", chain: "Rete",
      parcelsClaimed: "Parcel rivendicati", onChain: "on-chain", cellsAllocated: "Celle allocate",
      finiteWorld: "{pct}% del mondo finito", indexerHead: "Testa indexer", finalized: "finalizzato #{block}",
    },
    capacity: {
      territory: "Territorio", resolving: "Risoluzione territorio…", unavailable: "Capacità territorio non disponibile",
      area: "Area territorio", publishability: "Pubblicabilità", publishable: "Pubblicabile",
      notPublishable: "Non pubblicabile · Minimo {min} u²", gpCapacity: "Capacità GP", propertyUnits: "Unità di proprietà",
    },
    artworks: {
      title: "Opere su questa terra", scanning: "Scansione…",
      empty: "Nessuna Frozen Artwork è ancora collocata su questa terra.", untitled: "Opera senza titolo", view: "Vedi →",
    },
    zoomHint: {
      copy: "Fai zoom per esplorare The Grid. Al massimo ingrandimento scopri cosa i creator hanno pubblicato su ogni parcel.",
      controlDesktop: "Rotella o trackpad per lo zoom",
      controlMobile: "Pizzica per lo zoom",
      dontShow: "Non visualizzare più",
      close: "Chiudi",
      enteringParcels: "Stai entrando nei parcel",
    },
  },
  nav: {
    marketplace: "Marketplace",
    feed: "Feed",
    rent: "RENT",
    overview: "Panoramica",
    about: "Il Progetto",
    howItWorks: "Come Funziona",
    explore: "Esplora",
    creators: "Creator e Brand",
    creatorsShort: "Creator",
    territory: "Territorio",
    profile: "Profilo",
    enterGrid: "Entra nella Grid",
    signIn: "Accedi",
    navigate: "Naviga",
    purchaseBadge: "Acquisto",
    openMenuAria: "Apri il menu di navigazione",
    closeMenuAria: "Chiudi il menu di navigazione",
    primaryAria: "Principale",
    howItWorksHintAria: "Nuovo qui? Scopri come funziona THE GRID",
  },
  lang: { ariaLabel: "Lingua", menuLabel: "Scegli la lingua" },
  wallet: {
    connect: "Connetti",
    connecting: "Connessione…",
    myTerritories: "I miei territori",
    sessionDetails: "Dettagli sessione",
    disconnect: "Disconnetti",
  },
  auth: {
    title: "Sessione",
    subtitle: "Base di autenticazione wallet · SIWE + EIP-1271/6492",
    walletLabel: "Wallet",
    sessionLabel: "Sessione",
    connectPrompt: "Connetti un wallet dalla barra di navigazione per abilitare l'accesso.",
    loading: "Caricamento…",
    signedInAs: "Autenticato come {wallet}",
    expires: "scade: {date}",
    signOut: "Esci",
    signIn: "Accedi con Ethereum",
    chain: "rete: {name} ({id})",
    status: {
      requestingNonce: "Richiesta nonce…",
      requestingSignature: "Richiesta firma al wallet…",
      verifying: "Verifica della firma…",
      signedIn: "Autenticato come {wallet} (percorso: {path})",
      signedOut: "Disconnesso",
    },
  },
  home: {
    hero: {
      eyebrow: "// UN MONDO. POSSIBILITÀ FINITE.",
      paragraph:
        "Un unico territorio finito di un milione di celle. Esplora, rivendica e possiedi on-chain. Ogni parcella è coniata dallo stesso registro, assegnata una volta sola, per sempre.",
      enterGrid: "Entra nella Grid",
      scrollLine1: "Scorri per",
      scrollLine2: "Esplorare",
      scrollAria: "Scorri per esplorare",
    },
    instrument: {
      title: "Strumento",
      labels: { grid: "GRIGLIA", chain: "RETE", maxZoom: "MAX·Z", auth: "AUTH" },
    },
    callouts: {
      gridZero: { title: "Grid Zero", body: "Nucleo del territorio" },
      lattice: { title: "Reticolo di dati", body: "Confini delle zone on-chain" },
      cells: { label: "Celle · Finite" },
    },
    features: [
      { title: "Finito per Design", body: "1.000.000 di celle. Mai di più." },
      { title: "Costruito su Base", body: "Territorio on-chain · oggi su Base Sepolia." },
      { title: "Esplorabile da Tutti", body: "Leggi la mappa senza un wallet." },
      { title: "Di Proprietà del Wallet", body: "SIWE · EIP-1271 · EIP-6492 verificati." },
    ],
    story: {
      eyebrow: "La Nostra Storia",
      titleLine1: "UNA NUOVA ERA",
      titleLine2: "DELLA",
      titleHighlight: "PROPRIETÀ",
      paragraph:
        "La Grid è nata da un'idea semplice: un territorio digitale finito per costruzione, i cui confini vivono nel registro — non nella pagina di marketing. Ciò che possiedi qui, la blockchain lo ricorda.",
    },
    roadmap: {
      phaseLabel: "Fase",
      eyebrow: "Cronologia",
      phasesLive: "{live} di {total} fasi attive",
      title: "COSA È PRONTO. COSA ARRIVA.",
      paragraph:
        "Una mappa onesta, letta direttamente da Base. Fondamenta e Proprietà sono attive oggi — rivendica, crea, pubblica e fatti scoprire subito. Ora siamo nella fase di rifinitura e correzioni finali; il prossimo grande traguardo è il Mainnet, e comparirà qui solo quando sarà il registro, non il testo, a renderlo reale.",
      status: { live: "Attivo", next: "In corso", later: "Pianificato" },
      phases: [
        {
          title: "Fondamenta",
          items: [
            "Territorio canonico di 1.000.000 di celle su Base",
            "Indexer + reconciler on-chain attivi",
            "Autenticazione wallet SIWE · EIP-1271 · EIP-6492",
            "Esplorazione pubblica, senza wallet",
          ],
        },
        {
          title: "Proprietà e Creazione",
          items: [
            "Rivendica parcelle e pagamento in USDC su Base",
            "Canvas per creator — link, social, media, template",
            "Layer voxel 3D opzionale",
            "Pubblicazione + scoperta onesta su Explore",
          ],
        },
        {
          title: "Rifinitura finale",
          items: [
            "Fix di accettazione e rifinitura UX",
            "Copertura completa multilingua",
            "Hardening e QA finale prima del lancio",
            "Pagina anteprima Parcel RENT · rilascio pianificato Q1 2027",
          ],
        },
        {
          title: "Mainnet",
          items: [
            "Deploy su Mainnet (Base)",
            "Offerte, mercato secondario e attività",
            "Certificati e verifica dei creator",
            "API pubbliche ed estensioni",
          ],
        },
      ],
    },
    cta: {
      eyebrow: "Entra",
      titlePrefix: "SCEGLI IL TUO",
      titleHighlight: "TERRITORIO",
      paragraph:
        "La mappa che hai esplorato è pubblica. La proprietà no. Accedi con il tuo wallet per prendere posizione — il registro la ricorderà.",
      exploreGrid: "Esplora la Grid",
      signIn: "Accedi con Ethereum",
    },
    footer: {
      legalAria: "Note legali",
      legalToggle: "Note legali e policy",
      walletAuth: "Autenticato con wallet",
      territoryData: "Dati del territorio · letti on-chain",
    },
    slidedots: {
      aria: "Navigazione sezioni",
      overview: "Panoramica",
      story: "Storia",
      territory: "Territorio",
      roadmap: "Roadmap",
      enter: "Entra",
    },
  },
  about: {
    eyebrow: "Il Manifesto",
    titleLine1: "UN MONDO",
    titleHighlight: "FINITO.",
    intro:
      "THE GRID è un unico territorio digitale finito di un milione di celle, assegnato una sola volta e posseduto on-chain. Questo è ciò in cui crediamo e ciò che il prodotto fa davvero — niente di più, niente di inventato.",
    principles: [
      {
        title: "Finito per costruzione",
        body: "Un territorio. Un milione di celle. Mai di più. Qui la scarsità non è una scelta di marketing — è scritta nel contratto e non può essere gonfiata.",
      },
      {
        title: "La proprietà vive on-chain",
        body: "Una parcella è un asset on-chain su Base. Ciò che possiedi è registrato dal registro, non da noi. I confini del tuo territorio sono verificabili, non promessi.",
      },
      {
        title: "Pubblico per impostazione predefinita",
        body: "Chiunque può leggere la mappa — nessun wallet, nessuna registrazione. La scoperta è aperta. La proprietà è l'unica cosa che richiede di dimostrare chi sei.",
      },
      {
        title: "Una tela, non un cartellone",
        body: "Ogni territorio è una vera superficie di design: testo, link, social, media, forme e un layer 3D opzionale, tutto entro un budget onesto di Grid-Power derivato dalla tua terra.",
      },
      {
        title: "La tua identità, verificata",
        body: "Sign-In With Ethereum con wallet EOA e smart-contract (EIP-1271 / EIP-6492). Non custodiamo mai le tue chiavi e non spostiamo mai i tuoi fondi.",
      },
      {
        title: "Costruito per durare",
        body: "Il contenuto pubblicato è uno snapshot durevole, separato dalla tua bozza di lavoro. Modificare in seguito non altera mai ciò che il pubblico già vede finché non ripubblichi.",
      },
    ],
  },
  how: {
    eyebrow: "Il Percorso",
    titleLine1: "DALLA MAPPA",
    titleLine2: "ALLA PROPRIETÀ.",
    intro:
      "Sei passi reali, ognuno supportato da una funzionalità già disponibile. Questo è l'intero ciclo — esplora, rivendica, progetta, pubblica e fatti scoprire.",
    stepLabel: "PASSO {n}",
    toggle: { show: "Come funziona", hide: "Nascondi", aria: "Mostra una spiegazione semplice passo-passo" },
    steps: [
      {
        title: "Esplora la mappa",
        body: "Apri il Territorio e muoviti nella Grid finita 1000×1000. Zooma su qualsiasi parcella per vedere chi possiede cosa — senza bisogno di wallet.",
        detail: {
          intro: "Guardarsi intorno è del tutto gratuito e pubblico — nessun wallet, nessun account.",
          points: [
            "Apri Territorio dal menu in alto per vedere l'intera mappa: un'unica griglia di 1.000.000 di piccoli quadrati (celle).",
            "Trascina per spostarti, scorri per lo zoom. Zooma su qualsiasi area per vedere quale terra è occupata e cosa ci hanno messo i proprietari.",
            "Qui nulla ti chiede di accedere — leggere la mappa è sempre aperto a tutti.",
          ],
        },
      },
      {
        title: "Rivendica la tua parcella",
        body: "Disegna un rettangolo su terra libera e rivendicala su Base. La proprietà è coniata on-chain — la tua posizione è registrata dal registro, non da noi.",
        detail: {
          intro: "\"Rivendicare\" significa diventare proprietario di un rettangolo di celle libere. La proprietà è scritta su Base, una blockchain pubblica.",
          points: [
            "Ti servirà un wallet crypto — una piccola app gratuita del browser che dimostra che sei tu e approva le azioni.",
            "Oggi THE GRID gira su Base Sepolia, una rete di test, quindi usi USDC di test — non denaro reale.",
            "Sulla mappa, traccia un rettangolo su terra libera e conferma. Il tuo wallet firma e la parcella viene coniata a te.",
          ],
        },
      },
      {
        title: "Progetta il tuo Canvas",
        body: "Trasforma il tuo territorio in una vera pagina: titoli, link, social, contatti, media e forme — o parti da uno dei sei template premium. Tutto rientra in un budget onesto di Grid-Power derivato dall'area della tua terra.",
        detail: {
          intro: "La tua parcella è una pagina bianca che controlli tu. Riempila, o parti da un template già pronto.",
          points: [
            "Aggiungi titoli, link, pulsanti social, contatti, immagini, video e forme semplici.",
            "Preferisci un punto di partenza? Carica uno dei sei template premium e personalizza ogni dettaglio.",
            "Ogni parcella ha un budget di Grid-Power basato sulla sua dimensione — più terra ti permette di inserire di più. Mantiene le pagine oneste e veloci.",
          ],
        },
      },
      {
        title: "Aggiungi un layer 3D (opzionale)",
        body: "Dai profondità al tuo territorio con una scena voxel in cui i visitatori possono entrare zoomando. Del tutto opzionale — un Canvas piatto è comunque un risultato di prima classe.",
        detail: {
          intro: "Sopra la pagina piatta puoi aggiungere una piccola scena 3D fatta di blocchi (voxel).",
          points: [
            "I visitatori entrano nella scena mentre zoomano in profondità nella tua parcella.",
            "È del tutto opzionale — non devi mai crearne una.",
            "Un Canvas piatto senza 3D è un risultato completo e di prima classe.",
          ],
        },
      },
      {
        title: "Pubblica",
        body: "La pubblicazione crea uno snapshot durevole della tua bozza salvata. Continua a modificare in privato — il pubblico vede esattamente ciò che hai pubblicato finché non ripubblichi.",
        detail: {
          intro: "La pubblicazione crea una copia pubblica del tuo lavoro — mentre la tua bozza privata resta tua da modificare.",
          points: [
            "Crea uno snapshot durevole della tua bozza salvata e lo mostra al mondo.",
            "Puoi continuare a modificare in privato; i visitatori continuano a vedere la versione pubblicata.",
            "Nulla di ciò che cambi diventa pubblico finché non pubblichi di nuovo.",
          ],
        },
      },
      {
        title: "Fatti scoprire",
        body: "Ogni pubblicazione valida e attuale appare su Explore, dalla più recente — nessun pay-to-rank, nessun trending falso. Proprietà reale, contenuti reali, ordine onesto.",
        detail: {
          intro: "Una volta pubblicato, il tuo territorio è elencato per tutti — automaticamente e in modo equo.",
          points: [
            "Appare nella pagina Explore, dai più recenti.",
            "Non si paga per posizionarsi più in alto e non c'è nessun \"trending\" falso.",
            "Proprietà reale, contenuti reali, ordine onesto.",
          ],
        },
      },
    ],
    before: {
      eyebrow: "Inizia qui",
      title: "Prima di iniziare",
      intro: "Per guardarti intorno non serve quasi nulla. Ti serve un wallet solo quando decidi di possedere della terra.",
      items: [
        { title: "Per esplorare: niente", body: "Leggere la mappa e aprire qualsiasi pagina pubblicata è del tutto pubblico — nessun wallet, nessuna registrazione." },
        { title: "Un wallet crypto", body: "Per rivendicare e possedere ti serve un wallet: una piccola app gratuita del browser che dimostra che sei tu. Non custodiamo mai le tue chiavi né i tuoi fondi." },
        { title: "Fondi di test, non denaro reale", body: "Oggi THE GRID gira su Base Sepolia, una rete di test gratuita. Usi USDC di test per provare tutto in sicurezza." },
        { title: "Pochi minuti", body: "Rivendicare, progettare e pubblicare richiedono minuti — non ore." },
      ],
    },
    journey: {
      eyebrow: "Dall'inizio alla fine",
      title: "Il percorso completo",
      intro: "L'intero ciclo in un colpo d'occhio. Ogni passo porta naturalmente al successivo.",
      optional: "opzionale",
      steps: ["Esplora", "Rivendica", "Progetta", "Layer 3D", "Pubblica", "Fatti scoprire"],
    },
    draft: {
      eyebrow: "Due versioni",
      title: "Bozza vs Pubblicato",
      intro: "Il tuo lavoro vive sempre in due posti. Capire la differenza è tutto il trucco.",
      draftLabel: "Bozza",
      draftBody: "La tua copia di lavoro privata. La vedi solo tu. Modificala quanto vuoi, quando vuoi.",
      publishedLabel: "Pubblicato",
      publishedBody: "Uno snapshot pubblico durevole. È ciò che vedono i visitatori. Non cambia mai finché non pubblichi di nuovo.",
      takeaway: "Modificare la tua bozza è sempre sicuro — il pubblico continua a vedere la tua ultima versione pubblicata.",
    },
    levels: {
      eyebrow: "Tre livelli di zoom",
      title: "Come si vive THE GRID",
      intro: "Lo stesso territorio rivela di più man mano che ti avvicini.",
      items: [
        { tag: "Zoom indietro", title: "La mappa", body: "Vedi tutto il territorio finito in una volta e dove si trova ogni cosa." },
        { tag: "Zoom avanti", title: "Una pagina", body: "Zooma su una parcella e diventa una vera pagina — il Canvas del proprietario con testo, link e media." },
        { tag: "Più a fondo (opzionale)", title: "In 3D", body: "Continua a zoomare su una parcella che ha un layer 3D ed entri nella sua scena voxel." },
      ],
    },
    faq: {
      eyebrow: "Domande da principiante",
      title: "FAQ per principianti",
      intro: "Nuovo su THE GRID o sul Web3? Inizia da qui.",
      items: [
        { q: "Mi serve un wallet solo per guardare?", a: "No. Esplorare la mappa e aprire qualsiasi pagina pubblicata è del tutto pubblico e gratuito." },
        { q: "Cos'è un \"wallet\"?", a: "Una piccola app — spesso un'estensione del browser — che custodisce la tua identità on-chain e ti permette di approvare le azioni. Il controllo resta tuo; non custodiamo mai le tue chiavi né i tuoi fondi." },
        { q: "Sono soldi veri?", a: "Non oggi. THE GRID gira su Base Sepolia, una rete di test gratuita, con USDC di test — così puoi provare tutto in sicurezza." },
        { q: "Cosa sono celle e parcelle?", a: "THE GRID è un'unica mappa di 1.000.000 di piccoli quadrati chiamati celle. Una parcella è un rettangolo di celle che possiedi." },
        { q: "Posso cambiare la mia pagina dopo la pubblicazione?", a: "Sì. Mantieni una bozza privata e puoi modificarla quando vuoi. Il pubblico continua a vedere la tua ultima versione pubblicata finché non pubblichi di nuovo." },
        { q: "Cos'è la Grid-Power?", a: "Un semplice budget basato sulla dimensione della tua terra che limita quanto puoi inserire, mantenendo le pagine oneste e veloci da caricare." },
      ],
    },
  },
  explore: {
    eyebrow: "Scopri",
    titleLine1: "TERRITORI",
    titleHighlight: "PUBBLICATI.",
    intro:
      "Territori reali e attualmente attivi su THE GRID — dai più recenti. Nessun pay-to-rank, nessun trending inventato, nessun conteggio falso. Aprine uno per vedere la sua pagina pubblica.",
    error: {
      title: "Impossibile caricare la directory pubblica",
      body: "Il servizio di scoperta non è disponibile al momento. Riprova tra poco.",
      retry: "Riprova",
    },
    empty: {
      title: "La mappa è in attesa",
      body: "Nessun territorio è stato ancora pubblicato. Quando i creator pubblicheranno il loro Canvas, appariranno qui — dai più recenti. Potresti essere il primo.",
      claim: "Rivendica il tuo territorio",
      how: "Come funziona",
    },
    liveOne: "{count} territorio attivo",
    liveOther: "{count} territori attivi",
    modulesOne: "{count} modulo",
    modulesOther: "{count} moduli",
    untitled: "Territorio senza nome",
    view: "Vedi il territorio",
    badgeMedia: "Media",
  },
  creators: {
    eyebrow: "Creator e Brand",
    titleLine1: "IL TUO TERRITORIO,",
    titleHighlight: "IL TUO PALCO.",
    intro:
      "Qualunque cosa tu crei, c'è un punto di partenza. Sei template Canvas premium trasformano un territorio posseduto in una pagina finita in pochi minuti — poi modifichi ogni pixel. I template si caricano nella tua bozza dentro l'editor; nulla viene pubblicato finché non lo decidi tu.",
    sixTemplates: "Sei template premium",
    useCases: {
      creator: "Per chi crea un brand personale — un'identità decisa, bio e un'unica call to action.",
      retail: "Per piccoli negozi e brand — un'intestazione sopra uno scaffale prodotti con un percorso chiaro all'acquisto.",
      gallery: "Per artisti — l'opera guida, una dichiarazione discreta la accompagna.",
      music: "Per uscite ed eventi live — titolo, data, luogo e un link diretto a biglietti / streaming.",
      product: "Per i lanci — titolo, riga di supporto, tre blocchi funzionalità e una CTA.",
      minimal: "Per il minimalismo di alta gamma — sobrietà, spazio bianco e un'unica azione ponderata.",
    },
    noteBefore: "I template vivono nell'editor Canvas per un territorio che possiedi. Apri un territorio, premi ",
    noteBold: "Template",
    noteAfter: ", scegli un punto di partenza — riempie la tua bozza, e Salva / Pubblica restano nelle tue mani.",
    howCta: "Come funziona",
  },
  rent: {
    eyebrow: "Funzionalità pianificata",
    titleLine1: "PARCEL",
    titleHighlight: "RENT",
    intro: "Un modo pianificato per permettere ai proprietari di territori di affittare solo una parte del proprio territorio ai brand per campagne promozionali temporanee — mantenendo la piena proprietà del proprio parcel.",
    release: "Rilascio pianificato: Q1 2027",
    status: "Non ancora disponibile · Anteprima informativa",
    coexist: {
      eyebrow: "Territorio condiviso",
      title: "Un territorio. Due aree separate.",
      body: "Il proprietario mantiene il proprio spazio e la propria identità. La campagna di uno sponsor vivrebbe solo all'interno dell'area affittata, per un periodo limitato — le due coesistono fianco a fianco, senza mai mescolarsi.",
      ownerLabel: "Proprietario",
      sponsorLabel: "Sponsor",
      ownerLegend: "Area del proprietario — resta al proprietario",
      sponsorLegend: "Area dello sponsor — affittata, a tempo",
      caption: "Esempio illustrativo — non è un territorio o una campagna reali",
    },
    how: {
      eyebrow: "Come è previsto che funzioni",
      steps: [
        { title: "La proprietà resta", body: "Il parcel e il suo NFT non cambiano mai proprietario durante un affitto." },
        { title: "Si affitta solo una parte", body: "Il proprietario sceglie quale area offrire; il resto del territorio resta invariato." },
        { title: "Campagne temporanee", body: "Uno sponsor potrebbe pubblicare solo nell'area approvata, e l'accesso termina alla scadenza dell'affitto." },
        { title: "Verificato e ufficiale", body: "Verifiche d'identità previste per i partecipanti a RENT e pagamenti tramite il flusso di affitto ufficiale di The Grid." },
      ],
    },
    model: {
      eyebrow: "Modello di business proposto",
      title: "Reddito da affitto per i proprietari. Una commissione per The Grid.",
      body: "Secondo il modello proposto, il proprietario del territorio potrebbe ottenere un reddito dall'area affittata, mentre The Grid riceverebbe una commissione su ogni transazione di affitto ufficiale.",
      cards: [
        { title: "Proprietari", body: "Un potenziale reddito da affitto da una parte del territorio, senza vendere il parcel." },
        { title: "Brand", body: "Una presenza promozionale temporanea all'interno di territori di creator selezionati." },
        { title: "The Grid", body: "Una commissione sulle transazioni di affitto ufficiali." },
      ],
      note: "Livelli di commissione, prezzi e condizioni di affitto non sono ancora stati definiti.",
    },
    disclaimer: "Parcel RENT è una funzionalità pianificata e al momento non è disponibile. Oggi non è possibile prenotare, pagare o affittare. Dettagli, requisiti, prezzi e tempi di lancio possono cambiare; non sono garantiti guadagni, traffico o risultati.",
  },
  shellCta: {
    title: "La mappa è pubblica. La proprietà no.",
    body: "Esplora liberamente ogni territorio pubblicato. Quando sei pronto a rivendicare una posizione, accedi con il tuo wallet — il registro la ricorderà.",
    explore: "Esplora i territori",
    enterGrid: "Entra nella Grid",
  },
  onboarding: {
    profileEntry: { eyebrow: "Percorso guidato" },
    eyebrow: "Percorso guidato",
    title: "Lancia il tuo territorio",
    intro: "Un percorso guidato da zero a un territorio pubblicato. Niente è forzato — esci quando vuoi e riprendi da dove eri rimasto. Ogni passo ti porta allo strumento reale e i tuoi progressi vengono salvati.",
    authRequired: {
      title: "Accedi per iniziare la guida",
      body: "Il percorso guidato è legato al tuo wallet così i tuoi progressi vengono salvati. Collegare un wallet non basta — serve una sessione firmata.",
      cta: "Accedi con Ethereum",
    },
    loading: "Caricamento della tua guida…",
    error: {
      title: "Impossibile caricare la guida",
      body: "Il servizio guida non è disponibile al momento. Riprova tra poco.",
      retry: "Riprova",
    },
    progress: {
      label: "Passo {n} di {total}",
      complete: "{done} di {total} completati",
      statusDone: "Fatto",
      statusNow: "Ora",
      statusNext: "Prossimo",
      statusLocked: "Dopo",
    },
    restart: "Ricomincia la guida",
    restartConfirm: "Ricominciare la guida? Questo azzera solo i progressi guidati — i tuoi territori, bozze e pubblicazioni non vengono mai toccati.",
    ownershipLost: "Il territorio che avevi selezionato non è più di proprietà di questo wallet. Ti abbiamo riportato alla selezione del territorio.",
    actions: {
      select: "Seleziona",
    },
    personas: {
      selected: "Selezionato",
      creator: {
        label: "Creator",
        desc: "Un brand personale, un portfolio o una singola identità decisa con una call to action chiara.",
      },
      retail: {
        label: "Business / Retail",
        desc: "Un negozio, un prodotto o un brand — un'intestazione chiara su ciò che offri e un percorso per agire.",
      },
    },
    steps: {
      persona: {
        title: "Chi sei?",
        body: "Dicci se sei un Creator o un Business. Adattiamo i punti di partenza di conseguenza — puoi cambiarlo in qualsiasi momento.",
      },
      territory: {
        title: "Ottieni il tuo territorio",
        body: "Possiedi una parte della Grid, poi scegli quale territorio costruirà questa guida.",
        pick: "Scegli il territorio da costruire",
        selectedLabel: "In costruzione",
        needLand: "Non possiedi ancora terreno. Rivendica un parcel sulla Grid per iniziare.",
        getLand: "Ottieni terreno sulla Grid",
        nameIt: "Dai un nome a questo territorio",
        loading: "Risoluzione dei tuoi territori…",
        unavailable: "I dati di proprietà non possono essere risolti ora. Riprova tra poco.",
      },
      start: {
        title: "Scegli come iniziare",
        body: "Parti da un Canvas vuoto, oppure carica uno dei sei template premium e rendilo tuo. Entrambi aprono l'editor reale — niente viene pubblicato finché non lo decidi tu.",
        blank: "Parti da vuoto",
        template: "Usa un template",
        hint: "I template vivono nell'editor sotto \"Template\".",
      },
      build: {
        title: "Costruisci il tuo territorio",
        body: "Progetta il tuo Canvas: identità, media, link e contatti. Salva la bozza quando ti convince — resta privata finché non pubblichi.",
        open: "Apri l'editor Canvas",
        draftSaved: "Bozza salvata",
        noDraft: "Nessuna bozza ancora salvata",
      },
      publish: {
        title: "Pubblica",
        body: "La pubblicazione crea uno snapshot pubblico e duraturo della tua bozza salvata. Puoi continuare a modificare in privato; il pubblico vede la versione pubblicata finché non ripubblichi.",
        open: "Apri la pubblicazione",
        published: "Pubblicato",
        notReady: "Salva prima una bozza, poi pubblica dal tuo territorio.",
      },
      launch: {
        title: "Lancia e cresci",
        body: "Il tuo territorio è online. Condividilo — compare su Explore automaticamente, dal più recente, senza pay-to-rank.",
        viewPublic: "Vedi la tua pagina pubblica",
        explore: "Vedilo su Explore",
        copyLink: "Copia link pubblico",
        copied: "Link copiato",
        locked: "Pubblica il tuo territorio per sbloccare questo passo.",
      },
    },
    guide: {
      title: "Percorso guidato",
      heading: "Costruisci il tuo territorio",
      intro: "Aggiungi la tua identità, elementi visivi e link, poi salva la bozza.",
      items: {
        identity: "Aggiungi la tua identità (titolo, tagline)",
        media: "Aggiungi un elemento visivo o media",
        social: "Aggiungi social / contatti",
        save: "Salva la bozza",
      },
      back: "Torna alla guida",
      hide: "Nascondi guida",
    },
    entry: {
      eyebrow: "Nuovo qui?",
      title: "Lanciamo il tuo primo territorio",
      body: "Un breve percorso guidato ti porta dalla rivendicazione del terreno a una pagina pubblicata. Niente è forzato.",
      start: "Inizia la guida",
      notNow: "Non ora",
      resume: "Riprendi la guida",
      restart: "Ricomincia la guida",
      completed: "Guida completata",
    },
    creatorsCta: {
      title: "Nuovo su THE GRID? Segui il percorso guidato.",
      body: "Da un territorio posseduto a una pagina pubblicata in pochi passi guidati — template, costruzione, pubblicazione.",
      cta: "Inizia il percorso guidato",
    },
  },
  marketplace: {
    home: {
      eyebrow: "The Grid · Marketplace",
      title: "Possiedi, scambia e colleziona le coordinate di un mondo vivo.",
      subtitle: "Ogni annuncio è autoritativo lato backend e fail-closed. Parcel di terreno e opere congelate si regolano attraverso la stessa autorità di settlement on-chain — nulla viene mai inventato.",
      browseLand: "Esplora Terreni",
      browseArtworks: "Esplora Opere",
      cardLandTitle: "Terreni",
      cardLandDesc: "Parcel a prezzo fisso con pricing autoritativo per zona e floor cross-currency.",
      cardArtworksTitle: "Opere",
      cardArtworksDesc: "Opere congelate e posizionate, scambiate con royalty al creatore e aste live.",
      cardMineTitle: "Il Mio Mercato",
      cardMineDesc: "I tuoi annunci, offerte fatte e ricevute e rilanci d'asta in un unico posto.",
    },
    nav: {
      search: "Cerca",
      searchAria: "Cerca nel marketplace",
      notifications: "Notifiche",
      notificationsCountAria: "{count} notifiche",
    },
    search: {
      title: "Cerca nel marketplace",
      subtitle: "Parcel · opere · indirizzi",
      placeholder: "Parcel #, titolo opera o indirizzo wallet…",
      startTyping: "Inizia a digitare per cercare annunci e opere.",
      noMatches: "Nessun risultato per “{q}”.",
      land: "terreno",
      artwork: "opera",
      sellerPrefix: "Venditore {addr}",
      byPrefix: "di {addr}",
      auctionSuffix: " · asta",
    },
    notifications: {
      title: "Notifiche",
      offersOne: "{n} offerta da esaminare",
      offersMany: "{n} offerte da esaminare",
      offersDetail: "Alcuni acquirenti hanno fatto offerte sui tuoi asset.",
      outbidOn: "Superato su {title}",
      anAuction: "un'asta",
      topBid: "Rilancio più alto {top} · il tuo rilancio {yours}",
      allCaughtUp: "Sei in pari con tutto.",
      markAll: "Segna tutte lette",
    },
    land: {
      sectionTitle: "Annunci Terreni",
      loadErrorTitle: "Impossibile caricare gli annunci",
      loadErrorDetail: "L'indice del marketplace è irraggiungibile in questo momento. Nulla è stato modificato.",
      emptyNoneTitle: "Nessun terreno ancora in vendita",
      emptyNoneHint: "Quando i proprietari mettono in vendita dei parcel, appariranno qui.",
      emptyFilteredTitle: "Nessun annuncio corrisponde ai filtri",
      emptyFilteredHint: "Prova ad allargare la fascia di prezzo o a rimuovere il filtro di zona.",
      slots: "{n} slot",
      filters: {
        zone: "Zona",
        price: "Prezzo (USDC)",
        min: "Min",
        max: "Max",
        minSlots: "Slot minimi",
        any: "Qualsiasi",
        sort: "Ordina",
        clear: "Azzera filtri",
        sortRecent: "Più recenti",
        sortPriceAsc: "Prezzo · dal più basso",
        sortPriceDesc: "Prezzo · dal più alto",
        sortSlotsDesc: "Più grandi prima",
      },
    },
    zones: {
      all: "Tutte le zone",
      standard: "Standard",
      premium: "Premium",
      vip: "VIP",
      reserve: "Reserve",
      gridZero: "Grid Zero",
    },
    artworks: {
      loadErrorTitle: "Impossibile caricare le opere",
      loadErrorDetail: "L'indice della galleria è irraggiungibile in questo momento.",
      liveAuctions: "Aste Live",
      live: "{n} live",
      gallery: "Galleria",
      works: "{n} opere",
      emptyTitle: "Ancora nessuna opera",
      emptyHint: "Le opere congelate posizionate sulla Grid appaiono qui per offerte e aste.",
      auction: "Asta",
      openToOffers: "Aperta alle offerte",
      royalty: "{n}% royalty",
      by: "di {addr}",
    },
    detail: {
      backToLand: "Torna ai Terreni",
      backToArtworks: "Torna alle Opere",
      listingNotFound: "Annuncio non trovato",
      listingNotFoundDetail: "Questo annuncio potrebbe essere stato venduto o ritirato.",
      artworkNotFound: "Opera non trovata",
      artworkNotFoundDetail: "Questa opera potrebbe essere stata spostata o rimossa.",
      loadingParcel: "Caricamento parcel…",
      loadingArtwork: "Caricamento opera…",
      seller: "Venditore {addr}",
      creatorOwner: "di {creator} · proprietario {owner}",
      slots: "Slot",
      footprint: "Ingombro",
      floor: "Floor",
      size: "Dimensione",
      cells: "Celle",
      royalty: "Royalty",
      status: "Stato",
      yourListing: "Il tuo annuncio",
      buyNow: "Compra ora",
      unavailable: "Non disponibile",
      makeOffer: "Fai un'offerta",
      viewOnGrid: "Vedi sulla Grid",
      sellerNote: "Sei il venditore — acquisto e offerte sono disabilitati sul tuo annuncio.",
      ownerNote: "Possiedi questa opera — offerte e rilanci sono disabilitati per te.",
      openOffers: "Offerte Aperte",
      noOffersParcel: "Nessuna offerta aperta su questo parcel.",
      noOffersArtwork: "Nessuna offerta aperta su questa opera.",
      auctionTag: "Asta",
      openToOffers: "Aperta alle offerte",
      currentBid: "Rilancio attuale",
      reserve: "Riserva",
      leadingPrefix: "In testa {addr} · ",
      noBidsYet: "Ancora nessun rilancio · ",
      minNext: "min prossimo {amt} {sym}",
      auctionEnded: "Asta terminata",
      yourAuction: "La tua asta",
      placeBid: "Rilancia",
      buyTitle: "Compra Parcel #{id}",
      buySubtitle: "Settlement a prezzo fisso",
      done: "Fatto",
      cancel: "Annulla",
      reserving: "Prenotazione…",
      authorizing: "Autorizzazione…",
      reserveAuthorize: "Prenota e autorizza",
      signInRequired: "Accesso richiesto",
      connectSignIn: "Connetti il wallet e accedi →",
      settlementUnavailable: "Il settlement è temporaneamente non disponibile — nulla può essere addebitato ora.",
      price: "Prezzo",
      gridFee: "Commissione Grid",
      settlementAuthorized: "Settlement autorizzato",
      settlementAuthorizedBody: "L'autorità di settlement ha firmato il tuo permit. Completa l'acquisto dal tuo wallet per finalizzare on-chain.",
      authorityFloor: "Autorità {addr} · floor {amt} {sym}",
      completePurchase: "Completa acquisto",
      checkingAllowance: "Verifica autorizzazione…",
      confirmInWallet: "Conferma nel tuo wallet…",
      approvingUsdc: "Approvazione USDC…",
      settlingOnchain: "Finalizzazione on-chain…",
      purchaseComplete: "Acquisto completato",
      purchaseCompleteBody: "Il LAND è ora tuo. Proprietà e listing si aggiorneranno a breve.",
      buyFailed: "Acquisto non riuscito",
      approveRejected: "L'approvazione USDC è stata rifiutata nel wallet.",
      approveReverted: "La transazione di approvazione USDC è fallita on-chain (revert).",
      fillRejected: "L'acquisto è stato rifiutato nel wallet.",
      fillReverted: "La transazione di acquisto è fallita on-chain (revert).",
      wrongBuyerWallet: "Collega il wallet acquirente {addr} per completare l'acquisto.",
      makeOfferTitle: "Fai un'offerta",
      makeOfferSubtitle: "Offerta vincolante · scadenza in market-time",
      submitOffer: "Invia offerta",
      submitting: "Invio…",
      amount: "Importo",
      expiresIn: "Scade tra",
      dur1h: "1 ora",
      dur24h: "24 ore",
      dur3d: "3 giorni",
      dur7d: "7 giorni",
      placeBidTitle: "Piazza un rilancio",
      auctionFallback: "Asta",
      signing: "Firma…",
      yourBid: "Il tuo rilancio ({sym})",
      minNextBid: "Rilancio minimo successivo: {amt} {sym}",
      bidPermitSigned: "Permit di rilancio firmato",
      bidPermitBody: "L'autorità di settlement ha firmato il tuo permit di rilancio. Invialo dal tuo wallet per registrare il rilancio on-chain.",
      antiSnipe: " Il tuo rilancio cade nella finestra anti-snipe ed estenderà l'asta.",
      authorityMin: "Autorità {addr} · min accettato {amt} {sym}",
    },
    provenance: {
      title: "Cronologia / Provenienza",
      empty: "Nessuna cronologia di proprietà per questo parcel.",
      resale: "Rivendita",
      primaryPurchase: "Acquisto primario",
      privateSale: "Vendita privata",
      transfer: "Trasferimento",
      from: "Da",
      to: "A",
      price: "Prezzo",
      fee: "Commissione",
      net: "Netto",
      viewTx: "Vedi tx →",
      currentNameLabel: "Nome attuale",
    },
    owner: {
      cancelPrivateSale: "Annulla",
      cancelBlocked: "Non annullabile",
      cancelUnsupportedNote: "L'annullamento on-chain della vendita privata non è supportato dal contratto distribuito. Le richieste di annullamento falliscono in sicurezza e non modificano mai il record.",
      cancelPsTitle: "Annulla vendita privata",
      cancelPsBadge: "Azione owner",
      cancelPsWarning: "Verrà richiesto l'annullamento on-chain della vendita privata. Ha effetto solo dopo la conferma della transazione on-chain.",
      cancelPsSuccess: "Vendita privata annullata on-chain.",
      cancelPsConfirm: "Richiedi annullamento",
      cancelPsClose: "Chiudi",
      cancelPsUnsupported: "Il contratto distribuito non supporta l'annullamento on-chain della vendita privata. Nessun record è stato modificato.",
      psStatusActive: "Attiva",
      psStatusCompleted: "Completata",
      psStatusExpired: "Scaduta",
      psStatusCancelled: "Annullata",
      verifyingAccess: "Verifica accesso owner…",
      accessDeniedTitle: "Accesso owner richiesto",
      accessDeniedHint: "Questa console è riservata ai wallet owner in allow-list sul server. Accedi con un wallet admin.",
      loadErrorTitle: "Impossibile caricare la Owner Console",
      loading: "Caricamento Owner Console…",
      integrityTitle: "Integrità della Supply",
      noFreeGrant: "Nessun grant gratuito ✓",
      grantAnomaly: "Anomalia grant ✕",
      supplyActiveListings: "Annunci Attivi",
      supplySoldListings: "Annunci Venduti",
      supplyOpenOffers: "Offerte Aperte",
      supplyOpenAuctions: "Aste Aperte",
      supplyPendingSettlements: "Settlement in Sospeso",
      supplyPaidAcquisitions: "Acquisizioni Pagate",
      zeroPriceGrants: "Grant a prezzo zero",
      actionsTitle: "Azioni Owner",
      gridZeroManual: "Grid Zero manuale",
      releaseLabel: "Release",
      releaseDesc: "Rendi disponibile l'inventario idoneo. Cell-authoritative: rilasciate, non effettivamente riservate, non occupate.",
      relockLabel: "Relock",
      relockDesc: "Ri-blocca l'inventario disponibile. Non ri-blocca mai celle vendute, occupate o comunque non idonee.",
      privateSaleLabel: "Vendita Privata",
      privateSaleDesc: "Crea una vendita riservata a un acquirente. Il prezzo di tier è ufficiale; Grid Zero è manuale. Il prezzo deve essere > 0.",
      failClosed: "Fail-closed",
      unavailable: "Non disponibile",
      privateSalesTitle: "Vendite Private",
      noPrivateSalesTitle: "Nessuna vendita privata prevista",
      noPrivateSalesHint: "Le vendite private appaiono qui una volta create on-chain — annullabili fino al pending.",
      buyer: "acquirente {addr}",
      perSlot: "/ slot",
      executed: "Eseguita",
      pending: "In sospeso",
      supplyCheckTitle: "Controllo Supply",
      walletPlaceholder: "indirizzo wallet 0x",
      checking: "Verifica…",
      auditWallet: "Verifica wallet",
      supplyCheckFailed: "Controllo supply fallito",
      owned: "Posseduti",
      paidOrigin: "Origine pagata",
      integrity: "Integrità",
      consistent: "Coerente",
      anomalies: "Anomalie",
      confirmationSuffix: "conferma {tier}",
      tierNormal: "normale",
      tierStrong: "forte",
      tierMaximum: "massima",
      failClosedBanner: "Fail-closed: {reason}. Questa azione non può essere eseguita — nulla viene addebitato o inventato.",
      typeToProceedPre: "Digita ",
      typeToProceedPost: " per procedere",
      ack: "Comprendo che questa è un'azione owner cell-authoritative e confermo il target e la quantità.",
      confirmAction: "Conferma {action}",
      submitting: "Invio…",
      cancel: "Annulla",
      zoneLabel: "Zona",
      slotsLabel: "Slot",
      buyerLabel: "Wallet acquirente",
      priceLabel: "Prezzo unitario (USDC)",
      priceHintGridZero: "Grid Zero richiede un prezzo unitario manuale > 0.",
      priceHintTier: "Il prezzo di tier è ufficiale e applicato automaticamente.",
      actionSuccess: "Azione owner eseguita",
      actionSuccessBody: "{action}: {count} celle in {zone} — registrata nell'audit owner immutabile. Nessun grant gratuito, nessuna scrittura on-chain.",
      demoScope: "Preview Demo — substrate isolato, nessuna scrittura on-chain",
    },
    common: {
      parcelNumber: "Parcel #{id}",
      partialTag: "PARZIALE",
      close: "Chiudi",
      retry: "Riprova",
    },
    confirm: {
      normal: "Conferma questa azione owner cell-authoritative.",
      strong: "Questo interessa {slots} slot (oltre {threshold}). Reinserisci il numero esatto di slot per procedere.",
      maximum: "GRID ZERO è l'inventario più sensibile di THE GRID. È richiesta la conferma massima indipendentemente dalla quantità.",
    },
    statePill: {
      active: "attivo",
      sale_pending: "vendita in sospeso",
      confirming: "in conferma",
      sold: "venduto",
      expired: "scaduto",
      cancelled: "annullato",
      reconciliation_required: "riconciliazione richiesta",
      open: "aperto",
    },
    errors: {
      unauthenticatedTitle: "Accesso richiesto",
      unauthenticatedHint: "Connetti il wallet e accedi per autorizzare questa azione.",
      disabledTitle: "Mercato in pausa",
      disabledHint: "Il settlement è temporaneamente non disponibile. Nulla è stato addebitato o modificato — riprova quando riprende.",
      cellLockedTitle: "Riservato da un altro acquirente",
      cellLockedHint: "Una o più celle di questo parcel sono trattenute in questo momento dall'acquisto in sospeso di un altro acquirente. Riprova tra qualche minuto.",
      notActiveTitle: "Non più disponibile",
      notActiveHint: "Questo annuncio non è più attivo — potrebbe essere appena stato venduto o ritirato. Aggiorna per vedere l'ultima versione.",
      expiredTitle: "Annuncio scaduto",
      expiredHint: "Questo annuncio è scaduto e non può più essere acquistato. Il proprietario può ripubblicarlo.",
      selfTitle: "Questo è il tuo annuncio",
      selfHint: "Non puoi comprare o rilanciare su un asset che stai già vendendo.",
      belowFloorTitle: "Sotto il prezzo floor",
      belowFloorHint: "Il prezzo è cambiato e ora è sotto il floor del venditore. Rivedi e riprova.",
      settlementTitle: "Settlement in corso",
      settlementHint: "Un settlement per questo asset è già in corso. Attendi che si finalizzi prima di riprovare.",
      reconciliationTitle: "Riconciliazione richiesta",
      reconciliationHint: "Questo asset deve essere riconciliato con la chain prima di poter essere scambiato. Nessuna azione è stata eseguita.",
      spatialTitle: "Conflitto di posizionamento",
      spatialHint: "Questa opera non è in un posizionamento regolabile in questo momento — potrebbe essersi spostata o sovrapporsi a un altro posizionamento.",
      bidLowTitle: "Rilancio troppo basso",
      bidLowHint: "Il tuo rilancio è sotto il rilancio minimo successivo. Aumentalo e riprova.",
      permitReusedTitle: "Permit già usato",
      permitReusedHint: "Quel permit di rilancio è già stato speso. Piazza un nuovo rilancio.",
      auctionClosedTitle: "Asta chiusa",
      auctionClosedHint: "Questa asta non accetta più rilanci.",
      auctionNotStartedTitle: "Asta non iniziata",
      auctionNotStartedHint: "Questa asta non è ancora aperta ai rilanci.",
      sellerBidTitle: "I venditori non possono rilanciare",
      sellerBidHint: "Non puoi rilanciare sulla tua stessa asta.",
      permitRefusedTitle: "Autorizzazione rifiutata",
      permitRefusedHint: "L'autorità di settlement ha rifiutato di firmare. Nessuna azione è stata eseguita.",
      noBasisTitle: "Origine non registrata",
      noBasisHint: "Questo asset non ha ancora un'origine di acquisizione PAGATA registrata, quindi non può essere regolato. Nessuna azione è stata eseguita.",
      zeroAmountTitle: "Importo richiesto",
      zeroAmountHint: "Inserisci un importo maggiore di zero.",
      genericTitle: "Qualcosa è andato storto",
      genericHint: "L'azione non è stata completata. Nulla è stato modificato.",
    },

    tabs: {
      overview: "Panoramica",
      land: "Terreni",
      artworks: "Opere",
      mine: "Il Mio Mercato",
      owner: "Owner Console",
      ownerAria: "Owner Console — solo admin",
    },
    states: {
      loading: "Caricamento…",
      retry: "Riprova",
      active: "attivi",
    },
    paused: {
      title: "Mercato in pausa",
      body: "Il regolamento è temporaneamente non disponibile. La navigazione resta aperta; nulla può essere addebitato.",
    },
    mine: {
      signInTitle: "Accedi per vedere il tuo mercato",
      signInHint: "Connetti il wallet e accedi per vedere i tuoi annunci, offerte e rilanci.",
      connectSignIn: "Connetti e accedi →",
      loadErrorTitle: "Impossibile caricare il tuo mercato",
      loadingYours: "Caricamento del tuo mercato…",
      listings: "I Miei Annunci",
      listLand: "Vendi Terreno",
      noListings: "Nessun annuncio attivo",
      noListingsHint: "Metti in vendita un parcel dalla sua pagina di dettaglio — o usa Vendi Terreno.",
      offersReceived: "Offerte Ricevute",
      offersMade: "Offerte Fatte",
      bids: "I Miei Rilanci",
      noBids: "Nessun rilancio attivo",
      noBidsHint: "Rilancia in un'asta live per vederlo qui.",
      cancel: "Annulla",
      withdraw: "Ritira",
      noOpenOffers: "Nessuna offerta aperta",
      noOffersReceived: "Nessuna offerta ricevuta",
      offerMadeHint: "Fai un'offerta da qualsiasi annuncio o opera.",
      offerReceivedHint: "Le offerte sui tuoi asset appariranno qui.",
      accept: "Accetta",
      decline: "Rifiuta",
      accepting: "Accettazione…",
      acceptUnsupported: "Questo tipo di offerta non è ancora accettabile qui.",
      pendingPurchases: "Acquisti in Attesa",
      noPendingPurchases: "Nessun acquisto in attesa",
      pendingPurchasesHint: "Le offerte accettate dal venditore appariranno qui per completare l'acquisto.",
      completePurchase: "Completa acquisto",
      auction: "Asta",
      leading: "In testa",
      outbid: "Superato",
      bidPrefix: "rilancio",
      artworkLabel: "Opera",
      sales: "Vendite",
      purchases: "Acquisti",
      noSales: "Nessuna vendita",
      noSalesHint: "Le parcelle che vendi sul mercato secondario appariranno qui.",
      noPurchases: "Nessun acquisto",
      noPurchasesHint: "Le parcelle che acquisti sul mercato secondario appariranno qui.",
      soldTo: "Venduto a",
      boughtFrom: "Acquistato da",
      feeShort: "Commissione",
      netShort: "Netto",
      soldStatus: "Venduto",
      viewTx: "Vedi tx →",
    },
    sell: {
      slotsSelected: "Slot selezionati",
      partialBadge: "Area parziale",
      realSelectTitle: "Seleziona l'area da vendere",
      realSelectHint: "Clicca o trascina per selezionare le celle. Seleziona l'intero parcel per metterlo in vendita, oppure un'area contigua per una vendita parziale.",
      selectWhole: "Seleziona intero parcel",
      wholeSelectedNote: "Intero parcel selezionato — verrà messo in vendita per intero.",
      wholeIneligibleTitle: "Vendita dell'intero parcel non disponibile",
      wholeIneligibleBody: "Parte di questo parcel non è idonea — un lock di mercato attivo o contenuto canonico (un artwork posizionato) occupa una o più celle. L'inserzione dell'intero parcel è bloccata finché quelle celle non sono libere. Nessuna inserzione è stata creata.",
      partialDisabledTitle: "Vendita parziale non disponibile",
      partialVaultRequired: "La vendita di un'area parziale richiede un token figlio on-chain SubdivisionVault per questo parcel, che non esiste ancora. Crea la suddivisione on-chain prima di mettere in vendita quest'area. Nessuna inserzione è stata creata.",
      subdivisionTooComplex: "La forma selezionata supera il limite di suddivisione on-chain ({total}/{max} rettangoli) — modifica la selezione. Nessuna transazione inviata.",
      subAlreadySubdivided: "Questo parcel è già suddiviso on-chain. Ri-suddivisione non ancora supportata.",
      subDepositFailed: "Deposito del parcel nella vault non riuscito.",
      subSplitFailed: "Split on-chain della suddivisione non riuscito.",
      subGeometryMismatch: "La geometria del figlio on-chain non corrisponde alla selezione.",
      sub_plan: "Calcolo suddivisione…",
      sub_approve: "Approvazione vault…",
      sub_approveCollection: "Approvazione marketplace…",
      nftApprovalFailed: "Approvazione del trasferimento al marketplace non riuscita. Nessuna inserzione creata.",
      sub_deposit: "Deposito parcel…",
      sub_split: "Suddivisione on-chain…",
      sub_reconcile: "Riconciliazione…",
      sub_sign: "Firma e inserzione…",
      wholeTitle: "Metti in vendita l'intero parcel",
      wholeSubtitle: "Parcel #{id} · intero parcel",
      wholeBadge: "Intero parcel",
      wholeIntro: "Stai autorizzando una vendita REALE sul mercato secondario dell'INTERO parcel su Base Sepolia. Il tuo wallet firma un ordine EIP-712; nulla viene scritto on-chain finché un acquirente non lo esegue.",
      wholeConnectRequired: "Collega il wallet proprietario per autorizzare questo annuncio.",
      wholeOwnerMismatch: "Il wallet collegato non è il proprietario on-chain di questo parcel.",
      wholeNotConfigured: "Il contratto marketplace non è configurato per gli annunci reali.",
      signAndList: "Firma e pubblica",
      signing: "In attesa della firma del wallet…",
      reviewToken: "Token ID",
      reviewCollection: "Collection",
      realCreatedTitle: "Annuncio autorizzato",
      realCreatedBody: "Il tuo ordine firmato è attivo nel marketplace. Verrà regolato on-chain solo quando un acquirente lo esegue.",
      partialFutureTitle: "Vendi un sottoinsieme (parziale)",
      partialFutureBody: "La vendita parziale richiede un token figlio del subdivision-vault on-chain, non ancora disponibile su Base Sepolia. Al momento sono possibili solo annunci dell'intero parcel.",
      priceRealHelp: "Imposta il prezzo di vendita in {sym}.",
      listLand: "Vendi Terreno",
      sellLand: "Vendi Terreno",
      sellLandDemo: "Vendi Terreno · Preview Demo",
      previewDemo: "Preview Demo",
      previewDemoGrid: "Griglia Preview Demo",
      myLand: "I Miei Terreni",
      selectLand: "Seleziona Terreno",
      pickTitle: "Scegli il terreno da vendere",
      pickHint: "Seleziona uno dei tuoi parcel per mettere in vendita un sottoinsieme contiguo di celle.",
      pickEmpty: "Nessun terreno vendibile",
      pickEmptyHint: "Non possiedi terreni disponibili per la vendita parziale in questa preview.",
      pickCells: "{n} celle",
      pickListed: "{n} attivi",
      pickOpen: "Seleziona area →",
      wizardTitle: "Vendi Terreno",
      wizardSubtitle: "Parcel #{id} · Preview Demo",
      stepSelect: "Seleziona area",
      stepPrice: "Prezzo",
      stepReview: "Riepilogo",
      selectTitle: "Seleziona le celle da vendere",
      selectHint: "Clicca una cella per attivarla, o clicca e trascina per disegnare un rettangolo. La selezione deve essere un blocco contiguo e non può coincidere con l'intero parcel.",
      selectedCount: "{n} di {total} celle selezionate",
      clearSelection: "Pulisci",
      valLoading: "Validazione…",
      valValid: "Selezione valida",
      valInvalid: "Selezione non valida",
      basisLabel: "Costo di acquisizione",
      floorLabel: "Prezzo minimo di rivendita (80%)",
      floorBinding: "Vincolante",
      floorNotBinding: "Floor non vincolante (nessuna basis registrata)",
      reasonOutside: "Le celle sono fuori dal parcel",
      reasonNotContiguous: "Le celle devono formare un unico blocco contiguo",
      reasonFull: "È l'intero parcel — usa l'annuncio dell'intero parcel",
      reasonNotOwner: "Non sei il proprietario di questo terreno",
      reasonOverlap: "Alcune celle si sovrappongono a un annuncio esistente",
      reasonOccupied: "Alcune celle sono occupate da contenuto canonico",
      reasonNoBasis: "Prezzo minimo di rivendita non disponibile: nessuna base di costo di acquisizione registrata per questo parcel.",
      priceTitle: "Imposta il prezzo",
      priceLabel: "Prezzo",
      currencyLabel: "Valuta",
      priceHelpFloor: "Deve essere almeno il floor di {floor} {sym}.",
      belowFloor: "Il prezzo è sotto il floor minimo di {floor} {sym}.",
      reviewTitle: "Rivedi e autorizza",
      reviewCells: "Celle",
      reviewArea: "Area",
      reviewFloor: "Floor",
      reviewPrice: "Il tuo prezzo",
      authorize: "Autorizza e Pubblica",
      authorizeDemo: "Autorizza (Preview Demo) e Pubblica",
      creating: "Creazione annuncio…",
      createdTitle: "Annuncio demo creato",
      createdBody: "Il tuo annuncio preview demo è ora visibile in I Miei Annunci.",
      viewMine: "Vai a I Miei Annunci",
      demoDisclosureTitle: "Preview Demo — nessuna modifica on-chain / canonica",
      demoDisclosureBody: "Questo pubblica un parcel demo isolato sul substrate di preview. La tua sessione SIWE autorizza la scrittura; nessun mint on-chain del SubdivisionVault, nessun ordine EIP-712, nessun settlement su Base Sepolia. In produzione questo stesso flusso firma con il tuo wallet e regola on-chain.",
      back: "Indietro",
      next: "Avanti",
      close: "Chiudi",
    },
    artworkMkt: {
      buyNow: "Compra ora",
      listedAt: "In vendita a",
      fixedPrice: "Prezzo fisso",
      yourListing: "La tua inserzione",
      cancelListing: "Annulla inserzione",
      sellArtwork: "Vendi / Metti in vendita Opera",
      listArtwork: "Metti in vendita",
      buyTitle: "Compra “{title}”",
      buySubtitle: "Regolamento opera a prezzo fisso",
      buyIntro: "Stai comprando quest'opera al prezzo indicato. Il tuo wallet blocca USDC in escrow, poi la vendita si finalizza on-chain. Nulla si muove finché non confermi.",
      priceLabel: "Prezzo",
      royaltyLabel: "Royalty del creatore",
      gridFeeLabel: "Commissione Grid",
      confirmBuy: "Conferma e compra",
      buyPreparing: "Preparazione del regolamento…",
      buyCheckingAllowance: "Verifica allowance USDC…",
      buyApprove: "Approva USDC nel tuo wallet…",
      buyApproving: "Approvazione USDC…",
      buyOpenWallet: "Conferma l'escrow nel tuo wallet…",
      buyOpening: "Blocco fondi in escrow…",
      buyIndexingEscrow: "Conferma escrow on-chain…",
      buyAuthorizing: "Autorizzazione del pagamento…",
      buyReleaseWallet: "Conferma il pagamento nel tuo wallet…",
      buyReleasing: "Rilascio pagamento on-chain…",
      buyIndexingPayout: "Conferma finalità del pagamento…",
      buyFinalizing: "Trasferimento della proprietà…",
      buyComplete: "Acquisto completato",
      buyCompleteBody: "L'opera è ora tua. Proprietà e inserzioni si aggiornano a breve.",
      buyRejected: "L'azione è stata rifiutata nel tuo wallet.",
      buyReverted: "La transazione è fallita on-chain.",
      buyFailed: "Acquisto fallito",
      connectBuyer: "Connetti il wallet acquirente {addr} per completare l'acquisto.",
      sellIntro: "Possiedi quest'opera. Mettila in vendita a prezzo fisso o apri un'asta dal vivo.",
      cancelListingConfirm: "Annullare questa inserzione?",
      listingCancelled: "Inserzione annullata.",
      wizardTitle: "Vendi Opera",
      pickTitle: "Scegli un'opera da vendere",
      pickHint: "Seleziona un'opera congelata e posizionata che possiedi e che non è già in vendita o all'asta.",
      pickEmpty: "Nessuna opera vendibile",
      pickEmptyHint: "Ti serve un'opera congelata posizionata sulla Griglia che non sia già in vendita o all'asta.",
      chooseMode: "Come vuoi vendere?",
      modeFixed: "Prezzo fisso",
      modeFixedDesc: "In vendita a un prezzo stabilito. Gli acquirenti comprano subito; tu non firmi nulla on-chain.",
      modeAuction: "Asta",
      modeAuctionDesc: "Un'asta inglese a tempo con riserva. Firmi la creazione dell'asta on-chain.",
      setPrice: "Imposta il prezzo",
      priceHint: "Imposta il prezzo richiesto in {sym}. Commissione Grid {fee}% + royalty creatore {roy}% detratte al regolamento.",
      listBtn: "Metti in vendita",
      listing: "Pubblicazione…",
      listedTitle: "Opera in vendita",
      listedBody: "La tua opera è ora in vendita al prezzo fisso. Gli acquirenti possono comprarla dalla pagina di dettaglio.",
      setAuction: "Condizioni dell'asta",
      reserveLabel: "Prezzo di riserva",
      minIncrementLabel: "Rilancio minimo",
      durationLabel: "Durata",
      antiSnipeLabel: "Finestra anti-snipe",
      dur1h: "1 ora",
      dur6h: "6 ore",
      dur24h: "24 ore",
      dur3d: "3 giorni",
      dur7d: "7 giorni",
      antiSnipe60: "60 secondi",
      antiSnipe300: "5 minuti",
      antiSnipeOff: "Disattivata",
      createAuctionBtn: "Crea asta",
      creatingAuction: "Creazione asta…",
      auctionWalletConfirm: "Conferma l'asta nel tuo wallet…",
      auctionSubmitting: "Creazione asta on-chain…",
      auctionCreatedTitle: "Asta creata",
      auctionCreatedBody: "La tua asta è attiva on-chain. Gli offerenti possono rilanciare fino alla chiusura.",
      review: "Riepilogo",
      reviewArtwork: "Opera",
      reviewRoyalty: "Royalty",
      reviewMode: "Modalità",
      reviewPrice: "Prezzo",
      reviewReserve: "Riserva",
      reviewIncrement: "Rilancio",
      reviewEnds: "Termina",
      settleAuction: "Regola asta",
      settling: "Regolamento…",
      settleWalletConfirm: "Conferma il regolamento nel tuo wallet…",
      settled: "Asta regolata",
      cancelAuction: "Annulla asta",
      cancellingAuction: "Annullamento…",
      auctionCancelled: "Asta annullata.",
      bidPlacedOnchain: "Offerta registrata on-chain.",
      bidApprove: "Approva USDC nel tuo wallet…",
      bidApproving: "Approvazione USDC…",
      bidWalletConfirm: "Conferma l'offerta nel tuo wallet…",
      bidSubmitting: "Invio offerta on-chain…",
      historyTitle: "Storico / Provenienza",
      historyEmpty: "Ancora nessuno storico di vendite o aste per quest'opera.",
      histPrepared: "Regolamento preparato",
      histFinalized: "Venduta (prezzo fisso)",
      histAuctionSettled: "Asta regolata",
      histFrozen: "Congelata e posizionata",
      myArtworkListings: "Le Mie Opere in Vendita",
      noArtworkListings: "Nessuna opera in vendita",
      noArtworkListingsHint: "Metti in vendita un'opera congelata per vederla qui.",
      myAuctions: "Le Mie Aste",
      noMyAuctions: "Nessuna asta",
      noMyAuctionsHint: "Crea un'asta da un'opera che possiedi per vederla qui.",
      close: "Chiudi",
      cancel: "Annulla",
      back: "Indietro",
      next: "Avanti",
      done: "Fatto",
      viewTx: "Vedi tx →",
      signInFirst: "Connetti il wallet e accedi →",
      auctionEnds: "Termina {when}",
    },
    demoGrid: {
      title: "Griglia Preview Demo",
      subtitle: "I tuoi terreni demo · substrate di preview isolato",
      disclosure: "Questa è una superficie PREVIEW DEMO isolata — non la Griglia canonica. Nulla qui tocca parcel reali, ownership on-chain o Base Sepolia.",
      empty: "Non hai terreni demo in questa preview.",
      emptyHint: "Accedi con il wallet demo seller per vedere i terreni demo vendibili.",
      returnToMarket: "← Torna al Marketplace",
      ownedBadge: "Tuoi",
      listedBadge: "{n} in vendita",
      clickToSell: "Clicca un parcel per venderne una parte",
      worldLabel: "Mondo 1000 × 1000",
      loadError: "Impossibile caricare i tuoi terreni demo",
    },
    clock: {
      closing: "in chiusura",
      ended: "Terminata",
    },
    grid: {
      cellAria: "cella {x},{y}",
      cellLockedAria: "cella {x},{y} (bloccata)",
    },
  },
  purchase: {
    intro: "Anteprima del preventivo in tempo reale — nessun addebito finché non confermi.",
    loading: "caricamento…",
    bootstrapError: "Impossibile caricare /sale/config o /sale/status: {error}",
    recovery: {
      confirming: "Ripristinato un acquisto in sospeso — conferma in corso su Base…",
      syncing: "Confermato on-chain — sincronizzazione con la Grid…",
      failed: "La transazione di acquisto ripristinata è stata annullata. Nessuna parcella è stata acquistata.",
      degraded: "Rete temporaneamente non disponibile — nuovo tentativo sullo stato dell'acquisto…",
    },
    sections: {
      contracts: "Contratti on-chain",
      saleStatus: "Stato della vendita",
      wallet: "Wallet",
      financial: "Saldo e autorizzazione USDC",
      approval: "Autorizzazione USDC",
      purchase: "Acquisto",
      indexing: "Indicizzazione",
      quote: "Preventivo",
    },
    gate: { yes: "SÌ", no: "NO ({reason})" },
    wallet: {
      connect: "Connetti {name}",
      disconnect: "Disconnetti",
      wrongChain: "Il wallet è sulla chain {chainId}, la vendita è sulla {expectedChainId}. Cambia rete nel tuo wallet.",
      switching: "Cambio in corso…",
      switchTo: "Passa alla chain {chainId}",
      switchRejected: "cambio rifiutato",
      switchError: "errore di cambio: {message}",
    },
    financial: {
      blocked: "letture disabilitate: {reason}",
      readError: "errore di lettura",
      noSellableQuote: "— (nessun preventivo acquistabile)",
      insufficient: "insufficient_balance (mancano {amount})",
      approval: "approval_required (servono {amount})",
      ready: "ready_for_purchase",
      rpcError: "Errore RPC durante la lettura dello stato USDC.",
      refetch: "Ricarica saldo/autorizzazione",
    },
    approve: {
      blocked: "autorizzazione disabilitata: {reason}",
      waitingWallet: "In attesa del wallet…",
      submitting: "Invio in corso…",
      confirming: "Conferma in corso…",
      cta: "Autorizza USDC esatti",
      rejected: "L'utente ha rifiutato la transazione di autorizzazione. Puoi riprovare.",
      reverted: "La transazione di autorizzazione è stata annullata on-chain.",
      error: "Errore di autorizzazione: {error}",
      confirmed: "Autorizzazione confermata. Avviati la ricarica dell'autorizzazione e un nuovo preventivo forzato.",
    },
    tx: {
      blocked: "acquisto disabilitato: {reason}",
      refreshingQuote: "Aggiornamento del preventivo finale…",
      awaitingWallet: "Conferma nel tuo wallet…",
      submitted: "Inviato…",
      confirming: "Conferma su Base in corso…",
      cta: "Acquista",
      rejected: "L'utente ha rifiutato la transazione di acquisto.",
      reverted: "Transazione annullata",
      revertedReason: "Transazione annullata: {reason}",
      error: "Errore di acquisto: {error}",
      confirmed: "Transazione confermata on-chain. Sincronizzazione con la Grid — in attesa dell'indicizzazione backend…",
    },
    indexing: {
      pending: "Sincronizzazione con la Grid…",
      delayed: "Transazione confermata on-chain. L'indicizzazione backend sta richiedendo più tempo del previsto.",
      checkAgain: "Controlla di nuovo",
      success: "Posseduta · Live. Acquisto indicizzato correttamente.",
      buyAnother: "Acquista un'altra parcella",
      anomaly: "Rilevata anomalia di indicizzazione ({reason}). La transazione on-chain è confermata ma il record indicizzato non corrisponde allo snapshot di acquisto originale. Contatta l'assistenza con l'hash della transazione qui sotto.",
    },
    quote: {
      empty: "Disegna un rettangolo sulla griglia per ottenere un preventivo.",
      clearSelection: "Cancella selezione",
      occupiedSelf: "Quest'area si sovrappone a una parcella che possiedi già. Il terreno già coniato non può essere riacquistato.",
      occupiedOther: "Quest'area si sovrappone a terreno di proprietà di un altro wallet. Disegna su griglia libera per acquistare.",
      occupiedGeneric: "Quest'area si sovrappone a parcelle esistenti e non è acquistabile. Disegna su griglia libera.",
      loading: "caricamento preventivo…",
    },
    errors: {
      tooWide: "Selezione troppo larga — una singola parcella può essere larga al massimo 250 celle. Disegna un'area più stretta.",
      tooHigh: "Selezione troppo alta — una singola parcella può essere alta al massimo 250 celle. Disegna un'area più bassa.",
      areaExceeds: "Selezione troppo grande — una singola parcella può coprire al massimo 10.000 slot (celle){yours}. Disegna un'area più piccola per ottenere un preventivo.",
      areaExceedsYours: " — la tua è di {slots} slot",
      outOfBounds: "La selezione supera il bordo della Grid. Mantienila interamente dentro il territorio 1000 × 1000.",
      zeroOrNegative: "La selezione è vuota — disegna un rettangolo largo almeno una cella.",
      vipCap: "Quest'area VIP supera il limite commerciale per parcella. Disegna un'area più piccola.",
      zoneCap: "Quest'area supera la capacità residua della sua zona. Disegna un'area più piccola.",
      unexpected: "Errore imprevisto.",
    },
  },
  profile: {
    badge: { none: "Nessun badge ancora" },
    cockpit: {
      title: "Panoramica",
      available: "Disponibile",
      pendingFunding: "Finanziamento in sospeso",
      ownedParcels: "Parcelle possedute",
      influence: "Influenza",
      lifetimePts: "punti totali",
      slots: "{n} slot",
      progressTo: "Progresso verso {badge}",
      max: "max",
      referralCode: "Codice referral",
      qualified: "{n} qualificati",
      pending: "{n} in sospeso",
    },
    myGrid: {
      loading: "Caricamento della tua griglia…",
      signIn: "Accedi",
      unavailable: "Non disponibile.",
      failedToLoad: "Caricamento non riuscito",
      retry: "Riprova",
      title: "La mia Grid",
      empty: "Non possiedi ancora alcun terreno. Acquista una parcella per iniziare a guadagnare ricompense Vicinato e Influenza.",
      parcels: "Parcelle",
      totalSlots: "Slot totali",
      clusters: "Cluster",
      largestCluster: "Cluster più grande",
      slots: "{n} slot",
      parcelMeta: "{w}×{h} · {area} slot",
      edgeNeighbors: "{n} vicini di confine",
    },
    influence: {
      title: "Punteggio Influenza",
      lifetimePrivate: "Punti totali · privato",
      ptsTo: "{points} punti a ",
      maxReached: "Badge massimo raggiunto",
      nextAt: "prossimo a {threshold}",
      publicNote: "Le superfici pubbliche mostrano solo il tuo badge — mai il punteggio esatto. Nessuna classifica.",
    },
    analytics: {
      title: "Analisi",
      retry: "Riprova",
      loadError: "Impossibile caricare le tue analisi.",
      sections: { land: "Terreno e proprietà", creator: "Creator e referral", trends: "Tendenze", rewards: "Ricompense e Influenza" },
      kpi: {
        parcelsOwned: "Parcelle possedute",
        totalArea: "Area totale",
        primaryAcq: "Acquisizioni primarie",
        acqVolume: "Volume di acquisizione",
        ownedTerritories: "Territori posseduti",
        publishedTerritories: "Territori pubblicati",
        createdArtworks: "Opere create",
        qualifiedReferrals: "Referral qualificati",
        influence: "Influenza",
        rewardsAvailable: "Ricompense disponibili",
        totalRewards: "Ricompense totali",
        pendingFunding: "Finanziamento in sospeso",
      },
      cells: "celle",
      referralQ: "Qualifiche referral",
      inRange: "{n} nel periodo",
      noReferrals: "Nessun referral qualificato in questo periodo.",
      rewardsByType: "Ricompense per tipo",
      influenceGrowth: "Crescita dell'influenza",
      noInfluence: "Nessuna influenza in questo periodo.",
      notLiveTitle: "Ricompense e Influenza non sono ancora attive.",
      notLiveBody: "Queste metriche si popolano automaticamente quando il programma The Grid Rewards sarà attivo. Nulla viene tracciato o stimato fino ad allora.",
    },
    activity: {
      title: "Attività",
      markAll: "Segna tutto come letto ({n})",
      filters: { all: "Tutti", rewards: "Ricompense", land: "Terreno", artwork: "Opere", account: "Account" },
      loadError: "Impossibile caricare la tua attività.",
      retry: "Riprova",
      empty: "Nessuna attività ancora. Gli eventi rilevanti sulla tua Grid appariranno qui.",
      loading: "Caricamento…",
      loadMore: "Carica altro",
    },
    rewards: {
      loading: "Caricamento ricompense…",
      failedToLoad: "Impossibile caricare le ricompense",
      auth: { note: "Accedi per vedere il tuo saldo Ricompense e i prelievi.", cta: "Vai all'accesso" },
      unavailable: "Ricompense non disponibili.",
      retry: "Riprova",
      errors: {
        belowMin: "L'importo è sotto il minimo di 350 USDC.",
        exceedsAvailable: "L'importo supera il tuo saldo Disponibile.",
        invalidAmount: "Inserisci un importo valido.",
        unauthenticated: "La tua sessione è scaduta — accedi di nuovo.",
        failed: "Prelievo non riuscito.",
      },
      balance: {
        title: "Saldo Ricompense",
        available: "Disponibile",
        pendingFunding: "Finanziamento in sospeso",
        awaitingVault: "In attesa del finanziamento del Vault",
        withdrawalPending: "Prelievo in sospeso",
        withdrawn: "Prelevato",
        expired: "Scaduto",
        expiryDeadline: "Scadenza",
        forfeits: "Il Disponibile decade se non richiesto",
        noTimer: "Nessun timer attivo",
      },
      withdraw: {
        title: "Preleva",
        disabledNote: "Ti serve almeno {min} Disponibile per prelevare. Disponibile attuale: {available}.",
        amountLabel: "Importo (USDC)",
        gasLabel: "Stima gas di rete (USDC · facoltativo)",
        allToggle: "Preleva tutto il Disponibile ({available})",
        serviceFee: "Commissione di servizio · 2%",
        gasSeparate: "Gas (separato)",
        estimatedNet: "Netto stimato",
        minNote: "Minimo {min} lordo. Si applica una commissione di servizio del 2%; il gas di rete è addebitato separatamente ed è solo una stima.",
        belowMin: "Sotto il minimo di 350 USDC.",
        exceeds: "Supera il tuo saldo Disponibile.",
        submitting: "Invio in corso…",
        submit: "Preleva",
        all: "Preleva tutto",
        success: "Prelievo richiesto — netto {net} (commissione {fee}, gas {gas}).",
      },
      payout: {
        title: "Serve aiuto per il saldo?",
        body: "Avvisa il team di elaborare il tuo saldo Disponibile ({available}). Questo non crea denaro e non aggira mai l'ordine di finanziamento.",
        reachTitle: "Raggiungi {min} di profitti Disponibili per richiedere un pagamento",
        sending: "Invio in corso…",
        cta: "Richiedi pagamento",
        minHint: "Raggiungi {min} di profitti Disponibili per richiedere un pagamento — hai {available}.",
        alreadyOpen: "Una richiesta di pagamento è già aperta.",
        sent: "Richiesta di pagamento inviata al team.",
        failed: "Impossibile inviare la richiesta.",
      },
      history: {
        title: "Cronologia Ricompense",
        empty: "Ancora nessuna ricompensa. Le ricompense Referral (7%) e Vicinato (3%) appaiono qui man mano che il terreno viene acquisito.",
        referralProv: "Referral · {pct}% di {gross}",
        neighborProvEdge: "Vicinato · {edge}/{total} di confine di un pool {pct}%",
        neighborProvPool: "Vicinato · pool {pct}%",
        funded: "Finanziato",
        pendingFunding: "Finanziamento in sospeso",
        parcels: "parcelle {ids}",
      },
      withdrawals: {
        title: "Prelievi",
        pending: "In sospeso",
        withdrawn: "Prelevato",
        failed: "Non riuscito",
        net: "{net} netto",
        gross: "lordo {x}",
        fee: "commissione {x}",
        gas: "gas {x}",
        failureReason: "· {reason} — restituito al Disponibile per riprovare",
      },
    },
  },
  dashboard: {
    publishability: { published: "Pubblicato", publishable: "Pubblicabile", notPublishable: "Non pubblicabile" },
    territory: { fallback: "Territorio {ordinal}" },
    route: {
      title: "I miei territori",
      subtitle: "Centro di comando del proprietario · derivato dalla tua proprietà reale sulla Griglia",
      backToGrid: "Torna alla Griglia",
      authTitle: "Autenticazione richiesta",
      authBody: "Accedi con il tuo wallet per gestire i tuoi territori. Collegare un wallet non basta — è richiesta una sessione firmata.",
      signIn: "Accedi con Ethereum",
      detailEmpty: "Seleziona un territorio per vederne il riepilogo di gestione.",
    },
    list: {
      resolving: "Risoluzione dei tuoi territori…",
      unavailableTitle: "Territori non disponibili",
      unavailableBody: "I dati completi di proprietà non possono essere risolti in questo momento. Non viene mostrato nulla di parziale. Riprova a breve.",
      emptyTitle: "Nessun territorio ancora",
      emptyBody: "Non possiedi ancora alcuna proprietà sulla Griglia.",
      exploreGrid: "Esplora la Griglia",
    },
    card: {
      area: "Area",
      gpCapacity: "Capacità GP",
      propertyUnits: "Unità di proprietà",
      minNote: "Minimo 400 u² per pubblicare.",
      unreadTitle: "Un amministratore ti ha inviato un messaggio di moderazione",
      unreadAria: "Messaggio di moderazione non letto",
    },
    detail: {
      territoryArea: "Area del territorio",
      gpCapacity: "Capacità GP",
      propertyUnits: "Unità di proprietà",
      underlyingUnitIds: "ID unità sottostanti",
      location: "Posizione (confini del mondo)",
      minNote: "Questo territorio è sotto il minimo di 400 u² richiesto per pubblicare.",
    },
    identity: {
      title: "Identità del territorio",
      rev: "rev {n}",
      authRequired: "È richiesta una sessione firmata per gestire l'identità di questo territorio.",
      unavailable: "La gestione dell'identità è disponibile solo per un territorio legittimamente posseduto.",
      loading: "Risoluzione del territorio corrente…",
      namePlaceholder: "Nome visualizzato — dai un nome a questo territorio",
      saved: "Salvato.",
      saving: "Salvataggio…",
      saveName: "Salva nome",
      editCanvas: "Modifica canvas →",
      saveErrors: {
        STALE_TERRITORY: "Il tuo territorio è cambiato da quando è stato caricato. È stato aggiornato — rivedi e salva di nuovo.",
        IDENTITY_VERSION_CONFLICT: "Questa identità è stata aggiornata altrove. È stata aggiornata — rivedi e salva di nuovo.",
        IDENTITY_RECONCILIATION_REQUIRED: "Questo territorio ora si unisce a un altro territorio con nome. È richiesta la riconciliazione prima di salvare.",
        TERRITORY_NOT_PUBLISHABLE: "Questo territorio è sotto il minimo di 400 u² richiesto per pubblicare.",
        TERRITORY_NOT_IDENTITY_ELIGIBLE: "La gestione dell'identità è disponibile solo per un territorio legittimamente posseduto.",
        DISPLAY_NAME_INVALID: "Quel nome non è consentito.",
        UNTRUSTED_ORIGIN: "Questa richiesta è stata bloccata per sicurezza. Ricarica la pagina e riprova.",
        CSRF_REQUIRED: "Il tuo token di sicurezza mancava. Ricarica la pagina e riprova.",
        CSRF_INVALID: "Il tuo token di sicurezza è scaduto. Ricarica la pagina e riprova.",
        CSRF_FETCH_FAILED: "Impossibile verificare la tua sessione. Ricarica la pagina e riprova.",
        UNAUTHENTICATED: "La tua sessione è scaduta. Accedi di nuovo per salvare.",
        UNSUPPORTED_MEDIA_TYPE: "Qualcosa è andato storto durante l'invio della richiesta. Ricarica e riprova.",
        SEED_NOT_OWNED: "Non possiedi più questo territorio.",
      },
    },
    reconciliation: {
      intro: "Questo territorio ora unisce {n} territori con nome in uno solo. Scegli quale identità sopravvive — le altre vengono sostituite. I nomi non vengono uniti.",
      metaOne: "{n} unità · rev {rev}",
      metaOther: "{n} unità · rev {rev}",
      reconciling: "Riconciliazione…",
      confirmSurvivor: "Conferma sopravvissuto",
      errors: {
        STALE_TERRITORY: "Il tuo territorio è cambiato da quando è stato caricato. È stato aggiornato — rivedi e scegli di nuovo.",
        IDENTITY_VERSION_CONFLICT: "Una di queste identità è cambiata altrove. È stata aggiornata — rivedi e scegli di nuovo.",
        RECONCILIATION_NOT_REQUIRED: "Questo territorio non necessita più di riconciliazione. È stato aggiornato.",
        SURVIVOR_NOT_CANDIDATE: "Quell'identità non è più idonea. È stata aggiornata.",
        TERRITORY_NOT_PUBLISHABLE: "Questo territorio è sotto il minimo di 400 u² richiesto per pubblicare.",
        UNTRUSTED_ORIGIN: "Questa richiesta è stata bloccata per sicurezza. Ricarica la pagina e riprova.",
        CSRF_REQUIRED: "Il tuo token di sicurezza mancava. Ricarica la pagina e riprova.",
        CSRF_INVALID: "Il tuo token di sicurezza è scaduto. Ricarica la pagina e riprova.",
        CSRF_FETCH_FAILED: "Impossibile verificare la tua sessione. Ricarica la pagina e riprova.",
        UNAUTHENTICATED: "La tua sessione è scaduta. Accedi di nuovo.",
        TRANSACTION_UNAVAILABLE: "Il servizio è momentaneamente non disponibile. Riprova tra un istante.",
        SEED_NOT_OWNED: "Non possiedi più questo territorio.",
      },
    },
    brandImage: {
      title: "Immagine brand · LOD0",
      rev: "rev {n}",
      desc: "Immagine mappa opzionale per questo territorio (PNG · JPEG · WebP, ≤ 5 MiB, ≤ 2048px). Gratis.",
      recommendedPrefix: "Consigliata per il tuo territorio:",
      size: "{rw} × {rh} px",
      ratioNote: "(rapporto {ratio}) — corrisponde alla tua parcella così il logo non viene stirato.",
      previewAlt: "Immagine brand del territorio",
      unsaved: "Anteprima non salvata — premi Salva per mantenerla.",
      empty: "Nessuna immagine brand ancora.",
      saved: "Salvato.",
      removed: "Immagine brand rimossa.",
      authRequired: "È richiesta una sessione firmata per gestire l'immagine brand.",
      chooseAria: "Scegli un'immagine brand",
      replace: "Sostituisci…",
      select: "Seleziona immagine…",
      saving: "Salvataggio…",
      save: "Salva",
      cancel: "Annulla",
      remove: "Rimuovi",
      removeConfirm: "Rimuovere l'immagine brand?",
      removing: "Rimozione…",
      confirm: "Conferma",
      keep: "Mantieni",
    },
    publish: {
      publishing: "Pubblicazione…",
      republish: "Ripubblica",
      published: "Pubblicato",
      publish: "Pubblica",
      blockedSave: "Salva la bozza prima di pubblicare",
      stateLabels: {
        UNPUBLISHED: "Non pubblicato",
        PUBLISHED_CURRENT: "Pubblicato · attuale",
        DRAFT_CHANGED: "Pubblicato · bozza modificata",
        TERRITORY_CHANGED: "Pubblicato · territorio modificato",
      },
    },
    media: {
      fileTooLarge: "Il file supera il massimo di 250 MiB.",
      title: "Libreria multimediale",
      subtitle: "Media riutilizzabili del tuo wallet · Immagine 10 · GIF 20 (10s) · PDF 25 · Video 250 MiB · Libreria 2 GiB",
      working: "In corso…",
      upload: "Carica",
      used: "{x} usati",
      free: "{free} liberi su {total}",
      loading: "Caricamento libreria…",
      empty: "Nessun media ancora. Carica un'immagine, GIF, PDF o video per iniziare la tua libreria.",
      loadMore: "Carica altro",
      pages: "{n} pagine",
      deleteAria: "Elimina risorsa",
    },
  },
  artist: {
    utility: {
      loading: "Caricamento utilità parcella…",
      referral: {
        title: "Referral",
        yourCode: "Il tuo codice referral",
        copyLink: "Copia link referral",
        copied: "Copiato",
        qualified: "Referral qualificati",
        pending: "Referral in sospeso",
        empty: "Nessun referral ancora. Condividi il tuo link — un referral si qualifica quando il tuo invitato effettua la sua prima acquisizione di terreno primario.",
        preparing: "Il tuo codice referral è in preparazione dalla proprietà canonica — ricontrolla a breve.",
        ownToUnlock: "Possiedi almeno una parcella per sbloccare il tuo codice referral.",
        wasReferred: "Sei stato segnalato · stato",
      },
      parcel: {
        title: "Utilità parcella",
        empty: "Al momento non possiedi alcuna parcella. Acquisisci terreno per sbloccare l'utilità della parcella.",
        parcels: "Parcelle",
        totalArea: "Area totale",
        clusters: "Cluster",
        largestCluster: "Cluster più grande",
        flagBasicIdentity: "Identità di base",
        flagPublishable: "Pubblicabile",
        flagPublished: "Pubblicato",
        flagHasNeighbors: "Ha vicini",
        neighbors: "{n} vicini",
        cluster: "cluster {size} · {area} u²",
      },
      neighborhood: {
        title: "Vicinato",
        empty: "Possiedi una parcella per vedere il tuo vicinato.",
        edgeNeighbors: "Vicini di bordo",
        connectedClusters: "Cluster connessi",
        connectedClusterLabel: "Cluster connesso",
        clusterSummary: "{size} parcelle · {area} u²",
        openParcel: "Parcella #{id} — {n} vicino/i di bordo",
        loading: "Caricamento…",
        noEdgeNeighbors: "Nessun vicino di bordo.",
        yours: "tuo",
        published: "pubblicato",
      },
    },
    profile: {
      loading: "Caricamento profilo…",
      connectWallet: "Collega il tuo wallet",
      connectBody: "Accedi per vedere il tuo profilo Artista, idoneità e Capacità Creativa.",
      goToSignIn: "Vai all'accesso",
      unavailable: "Profilo non disponibile.",
      retry: "Riprova",
      loadFail: "Impossibile caricare il profilo",
      moderationLabel: "Moderazione",
      moderationMsg: "Messaggio dall'admin",
      moderationAria: "Hai un messaggio da un amministratore — apri I miei territori per leggerlo",
      tabs: { overview: "Panoramica", rewards: "Ricompense", activity: "Attività", analytics: "Analisi", grid: "La mia Griglia" },
      roleTitle: "Ruolo",
      roleArtist: "Sei un Artista — un'identità permanente ottenuta tramite idoneità del terreno e anzianità.",
      roleNeo: "Sei un NeoArtista — un'identità permanente con accesso accelerato alla creazione Artista una volta idoneo. Stesse capacità creative di un Artista.",
      roleCreator: "Attualmente possiedi terreno, quindi puoi usare gli strumenti creativi. Creatore è uno stato attuale — segue la tua proprietà del terreno e non è un badge permanente.",
      roleUser: "Al momento non possiedi terreno e non hai sbloccato un'identità artistica permanente. Acquisisci terreno per diventare un Creatore, o raggiungi il 50% di idoneità per il percorso NeoArtista.",
      statusCurrentState: "· stato attuale",
      eligTitle: "Idoneità Artista",
      neoThreshold: "Soglia NeoArtista · 50%",
      artistThreshold: "Soglia Artista · 100%",
      eligUnits: "{units} / {total} unità di idoneità",
      tierSlots: "{slots} slot · {units}u",
      tenureTitle: "Anzianità Artista · 100 giorni",
      tenureBlock: " (blocco {block})",
      tenurePending: "Prima acquisizione di terreno registrata on-chain{block}. La data esatta è in fase di risoluzione dai dati canonici della catena — l'anzianità verrà mostrata una volta disponibile. Nessuna data viene mostrata finché non può essere dimostrata.",
      firstAcq: "Prima acquisizione: {date}",
      daysLine: "{days} / {min} giorni",
      reqMet: "requisito soddisfatto",
      daysRemaining: "{n} giorni rimanenti",
      ccTitle: "Capacità Creativa",
      ccTotal: "Totale",
      ccUsed: "Usata",
      ccAvailable: "Disponibile",
      ccNote: "La capacità deriva dal terreno che possiedi e resta vincolata alla storia di ogni parcella.",
      neoTitle: "Percorso NeoArtista",
      neoHavePermanent: "Possiedi già un'identità permanente {status}.",
      neoNeedElig: "Raggiungi il 50% di Idoneità Artista per sbloccare il percorso NeoArtista accelerato (attualmente {pct}%).",
      neoEligibleBody: "Sei idoneo per il percorso NeoArtista accelerato (tariffa una tantum, in USDC o USDT). NeoArtista non concede Capacità Creativa extra.",
      neoFee: "Tariffa: {fee} · {currencies}",
      neoFeeNotConfigured: "Tariffa non ancora configurata — nessun prezzo viene mostrato finché The Grid non la imposta.",
      neoPaymentPending: "Integrazione pagamenti in sospeso",
      collectionTitle: "Collezione",
      collCreatedBy: "Creato da",
      collOwned: "Posseduto",
      collCreatedCount: "{n} creati",
      collCreatedEmpty: "Nessuna opera congelata ancora.",
      collOwnedEmpty: "Nessuna opera attualmente posseduta.",
      editTitle: "Modifica profilo",
      editDisplayName: "Nome visualizzato",
      editBio: "Bio",
      editAvatar: "URL avatar (https/ipfs)",
      editSaving: "Salvataggio…",
      editSave: "Salva",
      editSaved: "Salvato",
      editSaveFail: "Salvataggio non riuscito",
    },
  },
  social: {
    follow: { follow: "Segui", following: "Segui già", actionFailed: "Azione non riuscita" },
    report: {
      moreOptions: "Altre opzioni",
      reason: "Motivo",
      report: "Segnala",
      blockUser: "Blocca utente",
      reported: "Segnalato. Grazie.",
      reportFailed: "Segnalazione non riuscita",
      blocked: "Bloccato.",
      blockFailed: "Blocco non riuscito",
      reasons: {
        spam: "Spam", abuse: "Abuso", harassment: "Molestie", hate: "Odio",
        nsfw: "NSFW", scam: "Truffa", impersonation: "Impersonificazione", other: "Altro",
      },
    },
    bar: {
      save: "Salva", saved: "Salvato", comments: "Commenti",
      likeError: "Impossibile aggiornare il mi piace", saveError: "Impossibile aggiornare il salvataggio",
    },
    comment: {
      post: "Pubblica", postError: "Impossibile pubblicare", removed: "[rimosso]", you: "tu",
      reply: "Rispondi", hide: "Nascondi", viewOne: "Vedi {n} risposta", viewMany: "Vedi {n} risposte",
      delete: "Elimina", loadingReplies: "Caricamento risposte…", replyPlaceholder: "Scrivi una risposta…",
      heading: "Commenti", topPlaceholder: "Condividi le tue riflessioni su questo Territorio…",
      signin: "Accedi per unirti alla conversazione →", loading: "Caricamento commenti…",
      empty: "Nessun commento ancora. Sii il primo.", loadingMore: "Caricamento…", loadMore: "Carica altro",
    },
    creator: {
      signinPre: "Accedi", signinPost: "per vedere il tuo profilo.",
      none: "Nessun creatore specificato.", loading: "Caricamento profilo…", unavailable: "Profilo non disponibile.",
      followers: "Follower", following: "Seguiti", likes: "Mi piace", comments: "Commenti",
      territories: "Territori", published: "Pubblicati",
      gotoFeed: "Vai al tuo feed →", recentActivity: "Attività recente",
    },
    feed: {
      title: "Social", yourProfile: "Il tuo profilo →",
      following: "Seguiti", discover: "Scopri",
      followingSignin: "Accedi per vedere i creatori che segui →",
      loading: "Caricamento feed…", unavailable: "Feed non disponibile.",
      emptyFollowing: "Il tuo feed è silenzioso. Segui dei creatori per vedere qui i loro ultimi Territori e opere.",
      emptyDiscover: "Niente da scoprire ancora — i nuovi Territori pubblicati appaiono qui.",
      loadingMore: "Caricamento…", loadMore: "Carica altro",
      titlePublication: "Ha pubblicato un Territorio",
      titleArtworkNamed: "Ha pubblicato l'opera “{title}”",
      titleArtwork: "Ha pubblicato un'opera",
      titleAcquiredParcel: "Ha acquisito la parcella #{id}",
      titleAcquired: "Ha acquisito un nuovo Territorio",
    },
    handle: {
      heading: "Il tuo profilo social", handleLabel: "Handle", handlePlaceholder: "il_tuo_handle",
      save: "Salva", handleSaved: "Handle salvato.", handleError: "Impossibile salvare l'handle",
      handleHint: "3–24 caratteri · lettere, cifre, underscore · modificabile ogni 30 giorni.",
      linksLabel: "Link", linkLabelPlaceholder: "Etichetta", addLink: "+ Aggiungi link",
      saveLinks: "Salva link", linksSaved: "Link salvati.", linksError: "Impossibile salvare i link",
    },
  },
  legal: {
    navAria: "Navigazione documenti legali",
  },
  editor: {
    pixel: {
      title: "Pixel Studio",
      deleteTitle: "Elimina questo pixel art",
      delete: "Elimina",
      closeTitle: "Chiudi lo studio",
      startingPoint: "Punto di partenza",
      startingPointBody: "Abbiamo trasformato la tua immagine in pixel per darti una base. Ora rendila tua…",
      pencil: "Matita", eraser: "Gomma", fill: "Riempi", pick: "Preleva",
      undo: "Annulla", redo: "Ripeti", clear: "Pulisci", grid: "Griglia",
      importOpen: "Importa immagine → Pixel",
      brush: "Pennello", zoom: "Zoom",
      zoomOutTitle: "Zoom − (celle più piccole)", zoomInTitle: "Zoom + (celle più grandi)",
      cellsPainted: "Celle dipinte:",
      paletteActive: "Palette attiva", paletteActiveNote: "· immagine importata / disegno",
      add: "+ Aggiungi", recent: "Recenti",
      paletteBase: "Palette base", paletteBaseNote: "· colori standard THE GRID",
      saving: "Salvataggio…", saveArtworkCanvas: "Salva artwork + canvas",
      unsaved: "Non salvato", saved: "Salvato", close: "Chiudi",
      pixelizeTitle: "Pixelizza immagine", cancel: "Annulla",
      resultingGrid: "Griglia risultante:", colorsLabel: "colori:",
      resolution: "Risoluzione (lato lungo)", fitMode: "Adattamento",
      fitContain: "Contieni", fitCover: "Riempi", maxColors: "Colori max",
      dithering: "Dithering", on: "ON", off: "OFF",
      alphaThreshold: "Soglia trasparenza ({v})", useAsBase: "Usa come base",
      unsavedTitle: "Modifiche non salvate",
      unsavedBody: "Hai modifiche al pixel art non ancora salvate sul canvas. Cosa vuoi fare?",
      saveAndClose: "Salva e chiudi", discardClose: "Chiudi senza salvare",
    },
    voxel: {
      invalid: "Percorso editor 3D non valido.",
      authRequired: "Accedi con il tuo wallet per modificare questa scena 3D.",
      signIn: "Accedi →",
      loading: "Caricamento editor 3D…",
      back: "Indietro",
      empty: "Nessun territorio.",
      failedToLoad: "Caricamento non riuscito",
      noFootprint: "Questo territorio non ha parcelle possedute su cui costruire.",
      flashCreateFirst: "Crea o seleziona prima un'Opera",
      flashOutside: "Fuori dal tuo footprint posseduto",
      flashCleared: "Pezzo attivo svuotato",
      flashNoImage: "Impossibile leggere l'immagine",
      flashBaseInside: "La base deve restare dentro il tuo territorio",
      canvas: "Canvas",
      add: "Aggiungi", remove: "Rimuovi", cancelBase: "Annulla base",
      currentColorTitle: "Colore corrente (cambialo nella barra laterale)",
      undo: "Annulla", undoTitle: "Annulla (Ctrl+Z)",
      redo: "Ripeti", redoTitle: "Ripeti (Ctrl+Shift+Z)",
      clear: "Pulisci", clearTitle: "Svuota il pezzo attivo",
      resetView: "Reimposta vista",
      saving: "Salvataggio…", saved: "Salvato", save: "Salva",
      saveTitle: "Salva bozza 3D", saveOverTitle: "Oltre la capacità — rimuovi voxel per salvare",
      publishTitle: "La pubblicazione avviene sul Canvas — include automaticamente questa scena 3D salvata",
      publishLink: "Pubblica sul Canvas →",
      reload: "Ricarica",
      color: "Colore", customColorTitle: "Colore personalizzato",
      workArts: "Opere", newBase: "+ Nuova base",
      budgetLabel: "Budget:", cellsUnit: "celle",
      noWorkArts: "Nessuna opera ancora.",
      activePiece: "Pezzo attivo", rotate: "Ruota", rotationHint: "Reimposta la rotazione a 0° per modificare i voxel.",
      imageToVoxel: "Immagine → Voxel", depth: "Profondità", converting: "Conversione…", chooseImage: "Scegli immagine…",
      conversionHelp: "La conversione ti aiuta a partire con una semplice estrusione. Puoi rifinire il risultato voxel per voxel.",
      fallback: "La modifica 3D richiede WebGL, che questo dispositivo non è riuscito ad avviare. La tua bozza 3D è al sicuro — prova un browser desktop con accelerazione hardware.",
      defineTitle: "Definisci base — trascina sulla griglia",
      defineBody: "Trascina un rettangolo sul pavimento per dimensionare il tuo pezzo, poi rilascia per crearlo.",
      sizeLabel: "Dimensione", tooBig: "· troppo grande",
      noCapacityTitle: "Nessuna capacità 3D libera",
      noCapacityBody: "Non puoi ancora posizionare blocchi su questo territorio. Il regalo 3D gratuito (10.000+ voxel) è concesso solo al wallet che ha comprato una parcella nella vendita primaria e la possiede ancora. Le parcelle che sono state reclamate/mintate o comprate di seconda mano non ne ricevono.",
      hintNewBase: "Clicca su “+ Nuova base”, poi trascina sulla griglia per dimensionare il tuo pezzo.",
      howToBuild: "Come costruire",
      step1: "Clicca + Nuova base, poi trascina sulla griglia per dimensionare il pezzo",
      step2: "Clic sinistro sul pavimento / sulla faccia di un blocco per posizionare blocchi",
      step3: "Clic destro su un blocco per rimuoverlo",
      mouse: "Mouse", showControls: "Mostra controlli e come costruire", hide: "Nascondi",
      leftClick: "Clic sinistro", rightClick: "Clic destro", ctrlLeft: "Ctrl + sinistro", ctrlRight: "Ctrl + destro", scroll: "Scroll",
      drawBase: "Disegna base", placeBlock: "Posiziona blocco", removeBlock: "Rimuovi blocco", orbit: "Orbita attorno al clic", pan: "Sposta la vista", zoomInOut: "Zoom avanti / indietro",
      capacity3d: "Capacità 3D", overCapacity: "Oltre la capacità",
    },
    templates: {
      title: "Modelli Canvas",
      curatedStarts: "6 punti di partenza curati",
      close: "Chiudi modelli",
      apply: "Applica modello",
      previewAria: "Anteprima layout di {name}",
      replaceTitle: "Sostituire la bozza corrente?",
      replaceBody: "Applicando {name} sostituirai il contenuto della bozza corrente ({count} {unit}). Il tuo territorio pubblicato non viene toccato finché non salvi e pubblichi. Questa azione non può essere annullata se non con Annulla.",
      elementOne: "elemento",
      elementOther: "elementi",
      cancel: "Annulla",
      replaceDraft: "Sostituisci bozza",
      catalog: {
        creator: { name: "Creatore / Brand personale", useCase: "Identità personale", tagline: "Un'identità audace e centrata — nome, ruolo, bio, social e una singola call to action.", tag0: "Identità", tag1: "Bio", tag2: "Social" },
        retail: { name: "Retail / Vetrina", useCase: "Piccolo brand e negozio", tagline: "Un header di brand su uno scaffale prodotti ritmico, con una chiara azione visita-negozio.", tag0: "Prodotti", tag1: "Scaffale", tag2: "Link negozio" },
        gallery: { name: "Artista / Galleria", useCase: "L'opera al centro", tagline: "Un'unica cornice dominante con una dichiarazione sobria — l'opera guida, le parole seguono.", tag0: "Opera", tag1: "Dichiarazione", tag2: "Minimale" },
        music: { name: "Musica / Evento", useCase: "Uscita ed evento live", tagline: "Titolo ad alta energia, data e luogo, e un'azione diretta biglietti / streaming.", tag0: "Evento", tag1: "Data", tag2: "Biglietti" },
        product: { name: "Prodotto / Lancio tech", useCase: "Landing di lancio", tagline: "Una moderna pagina di lancio — titolo, riga di supporto, tre blocchi feature e una CTA.", tag0: "Lancio", tag1: "Feature", tag2: "CTA" },
        minimal: { name: "Lusso minimale", useCase: "Minimalismo di fascia alta", tagline: "Tipografia sobria e spazio generoso — una parola, una riga, un'azione.", tag0: "Lusso", tag1: "Spazio bianco", tag2: "Sobrietà" },
      },
    },
    error: {
      title: "Il canvas ha riscontrato un errore",
      body: "L'editor si è ripristinato invece di diventare nero. Le modifiche non salvate dall'ultimo salvataggio non sono state scritte sul server. Prova a ignorare per continuare, oppure ricarica l'editor per uno stato pulito.",
      dismiss: "Ignora",
      reload: "Ricarica editor",
    },
    canvas: {
      invalid: "Rotta del canvas non valida.",
      authRequired: "Accedi con il tuo wallet per modificare questo Canvas.",
      signIn: "Accedi →",
      loading: "Caricamento del Canvas…",
      empty: "Nessun canvas.",
      failedToLoad: "Caricamento non riuscito",
      back: "Indietro",
      close: "Chiudi",
      cancel: "Annulla",
      exitConfirm: "Hai modifiche non salvate. Vuoi uscire senza salvare?",
      flash: {
        saved3d: "Posizione 3D salvata",
        territoryChanged3d: "Territorio cambiato — ricarica l'editor",
        error3d: "3D: {code}",
        rotateOutside: "La rotazione uscirebbe dal territorio",
      },
      save: {
        territoryChanged: "Territorio cambiato — ricarica l'editor",
      },
      toolbar: {
        territories: "Territori",
        undo: "Annulla",
        redo: "Ripeti",
        fit: "Adatta territorio",
        templates: "Template",
        templatesTitle: "Parti da un template premium",
        templatesDisabledTitle: "I template richiedono un territorio di proprietà",
        mediaLibrary: "Libreria media",
        mediaLibraryTitle: "Libreria media — carica e sfoglia senza lasciare l'editor",
        artistProfile: "Profilo artista",
        artistProfileTitle: "Apri il tuo profilo artista",
        editor3d: "Editor 3D",
        editor3dTitle: "Apri l'editor voxel 3D per questo territorio",
        save: "Salva",
        saving: "Salvataggio…",
        saveTitle: "Salva canvas",
        saveOverTitle: "Capacità superata — riduci l'uso di GP per salvare",
        freeze: "Congela",
        freezeTitle: "Congela quest'opera di Pixel Studio",
        freezeBlockedTitle: "Salva il canvas prima di congelare",
      },
      tools: {
        pixelArt: "Pixel Art",
        new: "NUOVO",
        text: "Testo",
        interactive: "Interattivo",
        media: "Media",
        shapes: "Forme",
      },
      pixelDraw: {
        banner: "Disegna un riquadro sul tuo territorio",
      },
      pixelSize: {
        title: "Nuova Pixel Art",
        body: "Scegli una dimensione del canvas — 1 cella = 1 parcella. Le celle vuote restano trasparenti.",
        custom: "Personalizzato — disegna sul territorio",
      },
      mobileReadonly: "Solo lettura / ispezione su questo dispositivo. La modifica richiede uno schermo più grande.",
      gp: {
        used: "Usati",
        available: "Disponibili {n} GP",
        overCapacity: "Capacità superata",
      },
      status: {
        saved: "Salvato",
        unsavedChanges: "Modifiche non salvate",
        saving: "Salvataggio…",
        error: "Errore",
        showError: "Mostra l'errore completo",
      },
      inspector: {
        territoryTiers: "Livelli del territorio",
        globalStyle: "Stile globale",
        background: "Sfondo",
        bgColor: "Colore sfondo",
        perimeter: "Perimetro",
        perimeterGlow: "Bagliore perimetro",
        opacity: "Opacità {v}%",
        glow: "Bagliore",
        glowColor: "Colore bagliore",
        text: "Testo",
        label: "Etichetta",
        subtitleOptional: "Sottotitolo (opzionale)",
        urlHttps: "URL (https)",
        previewOpen: "Anteprima / Apri ↗",
        fill: "Riempimento",
        lineColor: "Colore linea",
        fit: "Adattamento",
        pixelArt: "Pixel Art",
        editPixels: "Modifica pixel",
        title: "Titolo",
        bgPreview: "Anteprima sfondo",
        changeImage: "Cambia immagine",
        addImage: "+ Aggiungi immagine",
        selectedGp: "GP {used} / {max} max",
      },
      controls: {
        preset: "Preset",
        layout: "Layout",
        direction: "Direzione",
        columns: "Colonne {v}",
        align: "Allineamento",
        gap: "Spaziatura {v}",
        iconSize: "Dimensione icona {v}",
        labelOptional: "Etichetta (opzionale)",
        labelColor: "Colore etichetta",
        brandColors: "Colori del brand",
        iconColor: "Colore icona",
        backgroundChip: "Chip di sfondo",
        bgColor: "Colore sfondo",
        border: "Bordo",
        borderColor: "Colore bordo",
        radius: "Raggio",
        padding: "Padding {v}",
        hover: "Hover",
        font: "Font",
        color: "Colore",
        textSize: "Dimensione testo {v}",
        style: "Stile",
        subtitleColor: "Colore sottotitolo",
        underline: "Sottolinea etichetta",
        icon: "Icona",
      },
      social: {
        links: "Link ({n}/5)",
        removeLink: "Rimuovi link",
        addLink: "+ Aggiungi link",
        showLabels: "Mostra etichette",
        labelFont: "Font etichetta",
        labelSize: "Dimensione etichetta {v}",
      },
      contacts: {
        heading: "Contatti ({n}/10)",
        removeContact: "Rimuovi contatto",
        addContact: "+ Aggiungi contatto",
        show: "Mostra",
        value: "Valore",
        dataColor: "Colore dati",
        kind: { EMAIL: "Email", PHONE: "Telefono", WHATSAPP: "WhatsApp", WEBSITE: "Sito web", MAP: "Indirizzo" },
        placeholder: { EMAIL: "nome@esempio.com", PHONE: "+39 055 000 1234", WHATSAPP: "+39 055 000 1234", WEBSITE: "https://esempio.com", MAP: "Via Roma 1, Città" },
      },
      layers: {
        title: "Livelli",
        empty: "Ancora nessun modulo.",
        front: "In primo piano",
        forward: "Avanti",
        backward: "Indietro",
        back: "In fondo",
        hide: "Nascondi",
        lock: "Blocca",
      },
      mediaPanel: {
        title: "Libreria media",
        working: "In corso…",
        upload: "Carica",
        hint: "Immagine 10 · GIF 20 (10s) · PDF 25 · Video 250 MiB · Libreria 2 GiB. I caricamenti compaiono subito nei selettori Aggiungi media.",
        loading: "Caricamento libreria…",
        empty: "Ancora nessun media. Carica un'immagine, GIF, PDF o video per iniziare la tua libreria.",
        loadMore: "Carica altro",
        deleteAria: "Elimina asset",
      },
      mediaPicker: {
        choose: "Scegli {kind} dalla Libreria media",
        empty: "Nessun asset {kind}. Carica prima nella Libreria media della Dashboard.",
      },
      mediaKind: { image: "immagine", gif: "GIF", video: "video", pdf: "PDF" },
      errorModal: {
        saveFailed: "Salvataggio non riuscito",
        gotIt: "Ho capito",
      },
      tier: { STANDARD: "Standard", PREMIUM: "Premium", VIP_CORE: "VIP Core", RESERVE: "Riserva", GRID_ZERO: "GRID ZERO" },
      enum: {
        module: { TITLE: "Titolo", TAGLINE: "Tagline", DESCRIPTION: "Descrizione", LINK: "Link", SOCIAL: "Social", CONTACTS: "Contatti", IMAGE: "Immagine", GIF: "GIF", VIDEO: "Video", PDF: "PDF", PIXEL_ART: "Pixel Art", SHAPE: "Forma" },
        shape: { RECTANGLE: "Rettangolo", ROUNDED_RECTANGLE: "Rettangolo arrotondato", ELLIPSE: "Ellisse", LINE: "Linea" },
        bgMode: { NEUTRAL: "Neutro", SOLID_COLOR: "Colore pieno" },
        glow: { OFF: "Off", LOW: "Basso", MEDIUM: "Medio", HIGH: "Alto" },
        direction: { HORIZONTAL: "Orizzontale", VERTICAL: "Verticale", GRID: "Griglia" },
        align: { START: "Inizio", CENTER: "Centro", END: "Fine" },
        textAlign: { LEFT: "Sinistra", CENTER: "Centro", RIGHT: "Destra", JUSTIFY: "Giustificato" },
        radius: { SQUARE: "Squadrato", SLIGHT: "Leggero", ROUNDED: "Arrotondato", PILL: "Pillola" },
        hover: { NONE: "Nessuno", LIFT: "Sollevamento", GLOW: "Bagliore", SCALE: "Scala" },
        fit: { COVER: "Riempi", CONTAIN: "Adatta" },
        contactsDisplay: { ICON: "Icona", ICON_LABEL: "Icona + etichetta", ICON_DATA: "Icona + dati", BUTTON: "Pulsante" },
        linkIcon: { NONE: "Nessuna", ARROW: "Freccia", FAVICON: "Favicon" },
        socialPreset: { ICONS_ONLY: "Solo icone", MINIMAL: "Minimale", BUTTONS: "Pulsanti", CARDS: "Schede" },
        contactsPreset: { ICONS_ONLY: "Solo icone", BUSINESS: "Business", MINIMAL: "Minimale" },
        linkPreset: { TEXT: "Testo", BUTTON: "Pulsante", OUTLINE: "Contorno", CARD: "Scheda" },
      },
    },
  },
};

export default it;
